// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.1
//   protoc               unknown
// source: configd/rest_fabrics.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { RestWarning } from "../common/error";
import { PaginationRequest, PaginationResponse } from "../common/grpc";
import { Timestamp } from "../google/protobuf/timestamp";
import {
  CablingPlanStatus,
  cablingPlanStatusFromJSON,
  cablingPlanStatusToJSON,
  DesignNodeData,
  RuleExecutionException,
} from "../models/cabling";
import {
  FabricTemplateType,
  fabricTemplateTypeFromJSON,
  fabricTemplateTypeToJSON,
  FabricTopology,
  fabricTopologyFromJSON,
  fabricTopologyToJSON,
  TaskStatusType,
  taskStatusTypeFromJSON,
  taskStatusTypeToJSON,
} from "../models/fabric";
import { CablingConnection, FabricDesign } from "../models/fabric_design";
import { FabricBlueprintTemplate, FabricTemplateFilters } from "../models/fabric_template";
import { Annotation, EntitlementLevel, entitlementLevelFromJSON, entitlementLevelToJSON } from "../models/global";
import { PortChannel } from "../models/models";
import { PerVlanStp } from "../models/routing";
import { Metadata, PortConnection } from "../models/types";
import { ExportedFabricConfiguration, FabricConfig } from "./api";

export const protobufPackage = "configd";

/**
 * A Fabric is a collection of nodes, connections that represents the interconnections
 * between the nodes, the configuration of the ports of the nodes and the logical constructs
 * deployed across the fabric such as VRFs, logical networks named VNIs and other services.
 */
export interface Fabric {
  /** The unique identifier of the fabric. */
  fabricId: string;
  /** The user-defined name of the fabric. */
  name: string;
  /** The description is a user-defined field to store notes about the fabric. */
  description: string;
  /** The location is a user-defined field to store information about the location of the fabric (E.g. SJC01). */
  location: string;
  /** The physical street address where the fabric is located (E.g. 320 My Street). */
  address: string;
  /** The city in which the fabric is located (E.g. San Jose). */
  city: string;
  /** The country code in which the fabric is located (E.g. US). */
  country: string;
  /** A list of user-defined labels that can be used for grouping and filtering fabrics. */
  labels: string[];
  /**
   * A list of name-value annotations to store user-defined data including complex data such as JSON
   * associated with the fabric.
   */
  annotations: Annotation[];
  /** A map of attributes related to the lifecycle of the fabric. */
  metadata:
    | Metadata
    | undefined;
  /** The type of topology of the fabric. */
  topology: FabricTopology;
  /** The blueprint template id to create the fabric blueprint from */
  templateId: string;
  /** Entitlement level associated with the fabric */
  entLevel: EntitlementLevel;
}

/** Get the list of all the blueprint templates */
export interface GetFabricTemplatesRequest {
  /** Filter by template types */
  templateType: FabricTemplateType[];
  /** Option to return template summary (connections, inventory, overrides) */
  includeTemplateSummary: boolean;
  /** This controls the top level tag aggregation */
  includeTemplateTagSummary: boolean;
  /** This controls whether or not we send the per template tags */
  includeTagsPerTemplate: boolean;
  gpuCount: number;
  deviceModelName: string[];
  portSpeed: string[];
  topologyArch: string[];
  property: string[];
  featureFlag: string[];
  switchModelName: string[];
}

export interface GetFabricTemplatesResponse {
  templates: FabricBlueprintTemplate[];
  templateTagSummary: FabricTemplateFilters | undefined;
}

/** Get the data for a blueprint template */
export interface GetFabricTemplateRequest {
  /** Required blueprint filter (id or name) */
  templateId: string;
  /** Option to return the fabric/fabric_design in response */
  includeExample: boolean;
  /** Option to return template summary (connections, inventory, overrides) */
  includeTemplateSummary: boolean;
}

export interface GetFabricTemplateResponse {
  /** Blueprint template object */
  template:
    | FabricBlueprintTemplate
    | undefined;
  /** Fabric/Fabric design object information. */
  exampleFabric: FabricConfig | undefined;
}

export interface GetCablingPlanRequest {
  fabricId: string;
  /** The candidate configuration name. If not set the default candidate configuration values are returned. */
  candidate: string;
  /** The group names to filter connections for */
  groupName: string[];
  /** The group ids to filter connections for */
  groupId: string[];
  /** The rail ids to filter connections for */
  railId: string[];
  /** The rail names to filter connections for */
  railName: string[];
  /** The node names to filter connections for */
  nodeName: string[];
  /** The node ids to filter connections for */
  nodeId: string[];
  excludeObservedStateDataInResponse: boolean;
}

export interface GetCablingPlanResponse {
  /** The persisted cabling plan from previous generation */
  connections: CablingConnection[];
  /** The current observed state for nodes in the fabric */
  observedConnections: CablingConnection[];
}

export interface GenerateCablingPlanRequest {
  fabricId: string;
  design: FabricDesign | undefined;
  dryRun: boolean;
  failFast: boolean;
  includeCablingPlan: boolean;
  /** this means configd will return back a 200 OK with an exception status and the list of exceptions. */
  includeExceptions: boolean;
  excludeObservedStateDataInResponse: boolean;
}

export interface GenerateCablingPlanResponse {
  fabricId: string;
  connections: CablingConnection[];
  execStatus: CablingPlanStatus;
  exceptions: RuleExecutionException[];
  observedConnections: CablingConnection[];
}

/** The request for a list of fabrics. */
export interface GetAllFabricsRequest {
  /** Filter by one or more fabric ids and or names. */
  fabricId: string[];
  /** The candidate configuration name. If not set the default candidate configuration values are returned. */
  candidate: string;
  /** Include object metadata in the response. */
  includeMetadata: boolean;
  /** The max number of fabrics to return in the response. */
  max: number;
  /** The unique identifier of the cursor representing the position of the next set in the list of fabrics. */
  cursor: string;
}

/** The response returned to a request for a list of fabrics. */
export interface GetAllFabricsResponse {
  /** A list of fabrics */
  fabrics: Fabric[];
  /**
   * The unique identifier of a cursor representing the position in the list of fabrics.
   * A cursor will only be provided if there are more fabrics to be returned.
   */
  cursor: string;
}

/** The request for a specific fabric. */
export interface GetFabricRequest {
  /** The fabric id or name. */
  fabricId: string;
  /** The candidate configuration name. If not set the default candidate configuration values are returned. */
  candidate: string;
  /** Include object metadata in the response. */
  includeMetadata: boolean;
}

/** The request to create a fabric. */
export interface AddFabricsRequest {
  /** A list of one fabric to be created. */
  fabrics: Fabric[];
}

/** The response returned to a request to create a fabric. */
export interface AddFabricsResponse {
  /** A list of the newly created fabric. */
  fabrics: Fabric[];
}

/** The request to create a fabric with a fabric design */
export interface AddFabricWithDesignRequest {
  fabric:
    | Fabric
    | undefined;
  /**
   * Only one of the following three design
   * sources are required:
   * The fully specified design
   */
  design:
    | FabricDesign
    | undefined;
  /**
   * The template id to generate the design
   * from
   */
  templateId: string;
  /** The fabric id to clone the design/logical objects from */
  sourceFabricId: string;
  /**
   * Node-device bindings from topology discovery. Used to bind discovered
   * devices to their corresponding design nodes during fabric creation.
   */
  discoveredNodeDeviceBindings: DesignNodeData[];
}

/** The response to create a fabric with a fabric design */
export interface AddFabricWithDesignResponse {
  /** The newly created fabric */
  fabric: Fabric | undefined;
}

/** The request to update a specific fabric. */
export interface UpdateFabricRequest {
  /** The fabric id or name. */
  fabricId: string;
  /** The updated fabric definition. */
  fabric: Fabric | undefined;
}

/** The request to update a specific fabric. */
export interface UpdateFabricWithDesignRequest {
  /** The fabric id or name. */
  fabricId: string;
  /** The updated fabric definition. */
  fabric:
    | Fabric
    | undefined;
  /** The updated fabric design */
  design:
    | FabricDesign
    | undefined;
  /**
   * Node-device bindings from topology discovery. Used to bind discovered
   * devices to their corresponding design nodes during fabric update.
   */
  discoveredNodeDeviceBindings: DesignNodeData[];
}

/** The request to delete a specific fabric. */
export interface DeleteFabricRequest {
  /** The fabric id or name. */
  fabricId: string;
}

/** The request for the list of connections in a specific fabric. */
export interface GetFabricConnectionsRequest {
  /** The fabric id or name. */
  fabricId: string;
  /** The candidate configuration name. If not set the default candidate configuration values are returned. */
  candidate: string;
}

/** The request for a specific connection in a fabric. */
export interface GetFabricConnectionRequest {
  /** The fabric id or name. */
  fabricId: string;
  /** The connection id, connections are not named. */
  connectionId: string;
  /** The candidate configuration name. If not set the default candidate configuration values are returned. */
  candidate: string;
}

/** The request to delete all connections in a specific fabric. */
export interface DeleteFabricConnectionsRequest {
  /** The fabric id or name. */
  fabricId: string;
}

/** The request to delete a specific connection in a fabric. */
export interface DeleteFabricConnectionRequest {
  /** The fabric id or name. */
  fabricId: string;
  /** The connection id or port name. */
  connectionId: string;
}

/** The request to add one or more connections to a specific fabric. */
export interface AddFabricConnectionsRequest {
  /** The fabric id or name. */
  fabricId: string;
  /** A list of connections to be added to the fabric. */
  connections: PortConnection[];
}

/** The request to update the list of connections in a specific fabric. */
export interface SetFabricConnectionsRequest {
  /** The fabric id or name. */
  fabricId: string;
  /** The list of connections for the fabric. */
  connections: PortConnection[];
}

/** The request to update a specific connection in a fabric. */
export interface SetFabricConnectionRequest {
  /** The fabric id or name. */
  fabricId: string;
  /** The connection id. */
  connectionId: string;
  /** The updated connection definition. */
  connection: PortConnection | undefined;
}

/** The response returned to a request for the list of connections in a specific fabric. */
export interface FabricConnectionsResponse {
  /** The list of connections in the fabric */
  connections: PortConnection[];
}

/** The request for the revision id of a specific fabric. */
export interface GetFabricRevisionIdRequest {
  /** The fabric id or name. */
  fabricId: string;
  /** optional filter to only return committed revisions */
  committed: boolean;
  /** optional string representing the duration in the form "72h3m0.5s" */
  lookbackDuration: string;
  /** optional look back start time if the lookback_minutes is not set */
  startTime: string;
  /** optional look back end time if the start_time is set */
  endTime: string;
  /** optional filter by user id (email) */
  userId: string;
  /** The max number of candidates to return in the response. */
  max: number;
  /** The optional cursor for REST based pagination. */
  cursor: string;
  /** Sort the revisions in descending order */
  sortDesc: boolean;
  /** grpc pagination */
  pagination: PaginationRequest | undefined;
}

/** The response to a request for the revision id of a specific fabric. */
export interface FabricRevisionIdResponse {
  /** The fabric id. */
  fabricId: string;
  /** The fabric name. */
  fabricName: string;
  /** The latest revision id for the fabric. */
  revisionId: string;
  /** List of past committed revisions */
  pastRevisions: CommittedRevisionMetadata[];
  /**
   * The unique identifier of a cursor representing the position in the list of revisions.
   * A cursor will only be provided if there are more fabrics to be returned.
   */
  cursor: string;
  pagination: PaginationResponse | undefined;
}

export interface CommittedRevisionMetadata {
  /** The external revision id being committed */
  revisionId: string;
  /** The user email that committed the revision */
  userId: string;
  /** The time the revision was committed */
  createdAt:
    | Date
    | undefined;
  /** The user provided commit comment */
  comments: string;
}

/** The request for the list of port channels in a specific fabric. */
export interface PortChannelsResponse {
  /** The list of port channels in the fabric. */
  portChannels: PortChannel[];
}

/** The request for the list of port channels in a specific fabric. */
export interface GetAllPortChannelsRequest {
  /** The fabric id or name. */
  fabricId: string;
  /** The candidate configuration name. If not set the default candidate configuration values are returned. */
  candidate: string;
  /** Include object metadata in the response. */
  includeMetadata: boolean;
}

/** The request for the a specific port channel in a fabric. */
export interface GetPortChannelRequest {
  /** The fabric id or name. */
  fabricId: string;
  /** The configuration candidate name. If not set the default candidate configuration values are returned. */
  candidate: string;
  /** The port channel id or name. */
  id: string;
  /** Include object metadata in the response. */
  includeMetadata: boolean;
}

/** The request to add one or more port channels to a specific fabric. */
export interface AddPortChannelsRequest {
  /** The fabric id or name. */
  fabricId: string;
  /** A list of port channels to be added to the fabric. */
  portChannels: PortChannel[];
}

/** The request to update a specific port channel in a fabric. */
export interface UpdatePortChannelRequest {
  /** The fabric id or name. */
  fabricId: string;
  /** The port channel id or name. */
  id: string;
  /** The updated port channel definition. */
  portChannel: PortChannel | undefined;
}

/** The request to delete a specific port channel in a fabric. */
export interface DeletePortChannelRequest {
  /** The fabric id or name. */
  fabricId: string;
  /** The port channel id or name. */
  id: string;
}

/** Get spanning tree settings for a fabric. */
export interface GetFabricStpRequest {
  /** The fabric id or name. */
  fabricId: string;
  /** The configuration candidate name. If not set the default candidate configuration values are returned. */
  candidate: string;
  /** Include metadata information. */
  includeMetadata: boolean;
}

/** The request to update the global spanning tree protocol settings of a fabric. */
export interface UpdateFabricStpRequest {
  /** The fabric id or name. */
  fabricId: string;
  /** The updated spanning tree settings. */
  stp: PerVlanStp | undefined;
}

/** The request to reset the global spanning tree protocol settings of a fabric. */
export interface ResetFabricStpRequest {
  /** The fabric id or name. */
  fabricId: string;
}

export interface StreamConfigRequest {
  fabricId: string;
}

/** RevertFabricRevisionRequest encapsulates properties to revert */
export interface RestoreFabricRevisionRequest {
  /** The fabric id or name. */
  fabricId: string;
  /** The target revision id to revert to. */
  revisionId: string;
  /** If true, the revert will be simulated but not applied. */
  dryRun: boolean;
  /** Password for decrypting the secret in the revision_config. */
  password: string;
  /** If true, the revert will be automatically committed. */
  autoCommit: boolean;
  /** The exported fabric revision. */
  revisionConfig: ExportedFabricRevision | undefined;
}

/** The fabric configuration at a specific revision */
export interface FabricRevisionConfig {
  metadata: CommittedRevisionMetadata | undefined;
  config: FabricConfig | undefined;
}

/** The response to a request to revert a fabric to a specific revision. */
export interface RestoreFabricRevisionResponse {
  /** The restored fabric configuration. */
  restoredConfig:
    | FabricConfig
    | undefined;
  /** A list of warnings that occurred during the revert operation */
  warnings: RestWarning[];
}

/** The request to creates an export record for a fabric configuration revision. */
export interface CreateFabricRevisionExportRequest {
  /** The fabric id or name. */
  fabricId: string;
  /** The revision id. */
  revisionId: string;
  /** Password for generating key to for secret encryption. */
  password: string;
}

export interface ExportedFabricRevision {
  /** The fabric id */
  fabricId: string;
  /** the fabric name */
  fabricName: string;
  /** Metadata about the exported revision. */
  revisionMetadata:
    | CommittedRevisionMetadata
    | undefined;
  /** Metadata about the export operation. */
  exportMetadata:
    | ExportedRevisionMetadata
    | undefined;
  /** The exported fabric configuration. */
  config: ExportedFabricConfiguration | undefined;
}

export interface ExportedRevisionMetadata {
  /** The time at which the revision was created. */
  exportedAt:
    | Date
    | undefined;
  /** The user who exported the revision. */
  exportedBy: string;
  /** The cipherText that holds the encrypted configuration secret. */
  secret: string;
}

export interface CloneFabricRequest {
  /** The fabric id or name. */
  fabricId: string;
  /** The name of the new cloned fabric. */
  cloneName: string;
  /**
   * If true, the clone operation is queued for background processing and the
   * response is returned immediately with a task_id that can be polled.
   */
  background: boolean;
}

/**
 * CloneFabricResponse wraps the result of a CloneFabric call.
 * When background=false the config field is populated with the full FabricConfig.
 * When background=true only task_id and task_status are populated (HTTP 202).
 */
export interface CloneFabricResponse {
  /** The cloned fabric configuration (populated when background=false). */
  config:
    | FabricConfig
    | undefined;
  /** The queued task identifier (populated when background=true). */
  taskId: string;
  /** The task status (populated when background=true). */
  taskStatus: TaskStatusType;
}

/** The request to get deleted fabrics. */
export interface GetDeletedFabricsRequest {
  /** optional string representing the duration in the form "72h3m0.5s" */
  lookbackDuration: string;
  /** optional look back start time if the lookback_minutes is not set */
  startTime: string;
  /** optional look back end time if the start_time is set */
  endTime: string;
  /** optional filter by user id (email) */
  userId: string;
  /** The max number of candidates to return in the response. */
  max: number;
  /** The optional cursor for REST based pagination. */
  cursor: string;
  /** Sort the revisions in descending order */
  sortDesc: boolean;
  /** grpc pagination */
  pagination: PaginationRequest | undefined;
}

/** The response to a request to get deleted fabrics. */
export interface GetDeletedFabricsResponse {
  fabrics: DeletedFabricMetadata[];
  cursor: string;
  pagination: PaginationResponse | undefined;
}

/** The request to creates an export record for a fabric configuration revision. */
export interface CreateDeletedFabricExportRequest {
  /** The fabric id or nameof the deleted fabric */
  fabricId: string;
  /** Password for generating key to for secret encryption. */
  password: string;
}

/** RevertFabricRevisionRequest encapsulates properties to revert */
export interface RestoreDeletedFabricRequest {
  /** The fabric id or name of the deleted fabric */
  fabricId: string;
  /** If true, the revert will be simulated but not applied. */
  dryRun: boolean;
  /** If true, the revert will be committed automatically. */
  autoCommit: boolean;
  /** Password for decrypting the secret in the revision_config. */
  password: string;
  /** The exported fabric revision. */
  revisionConfig: ExportedFabricRevision | undefined;
}

/** Metadata about a deleted fabric */
export interface DeletedFabricMetadata {
  /** The fabric name */
  fabricName: string;
  /** The fabric id */
  fabricId: string;
  /** The user email that deleted the fabric */
  deletedBy: string;
  /** The time the fabric was deleted */
  deletedAt: Date | undefined;
}

/** The request to get a shareable link for a specific fabric. */
export interface GetFabricShareableLinkRequest {
  /** The fabric id or name. */
  fabricId: string;
}

/** The response containing the shareable link for a fabric. */
export interface GetFabricShareableLinkResponse {
  /** The fabric id. */
  fabricId: string;
  /** The fabric name. */
  fabricName: string;
  /** The shareable link path for the fabric */
  link: string;
}

function createBaseFabric(): Fabric {
  return {
    fabricId: "",
    name: "",
    description: "",
    location: "",
    address: "",
    city: "",
    country: "",
    labels: [],
    annotations: [],
    metadata: undefined,
    topology: 0,
    templateId: "",
    entLevel: 0,
  };
}

export const Fabric: MessageFns<Fabric> = {
  encode(message: Fabric, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.description !== "") {
      writer.uint32(26).string(message.description);
    }
    if (message.location !== "") {
      writer.uint32(34).string(message.location);
    }
    if (message.address !== "") {
      writer.uint32(42).string(message.address);
    }
    if (message.city !== "") {
      writer.uint32(50).string(message.city);
    }
    if (message.country !== "") {
      writer.uint32(58).string(message.country);
    }
    for (const v of message.labels) {
      writer.uint32(66).string(v!);
    }
    for (const v of message.annotations) {
      Annotation.encode(v!, writer.uint32(74).fork()).join();
    }
    if (message.metadata !== undefined) {
      Metadata.encode(message.metadata, writer.uint32(82).fork()).join();
    }
    if (message.topology !== 0) {
      writer.uint32(88).int32(message.topology);
    }
    if (message.templateId !== "") {
      writer.uint32(106).string(message.templateId);
    }
    if (message.entLevel !== 0) {
      writer.uint32(112).int32(message.entLevel);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Fabric {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFabric();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.location = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.address = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.city = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.country = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.labels.push(reader.string());
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.annotations.push(Annotation.decode(reader, reader.uint32()));
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.metadata = Metadata.decode(reader, reader.uint32());
          continue;
        }
        case 11: {
          if (tag !== 88) {
            break;
          }

          message.topology = reader.int32() as any;
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.templateId = reader.string();
          continue;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.entLevel = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Fabric {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      location: isSet(object.location) ? globalThis.String(object.location) : "",
      address: isSet(object.address) ? globalThis.String(object.address) : "",
      city: isSet(object.city) ? globalThis.String(object.city) : "",
      country: isSet(object.country) ? globalThis.String(object.country) : "",
      labels: globalThis.Array.isArray(object?.labels) ? object.labels.map((e: any) => globalThis.String(e)) : [],
      annotations: globalThis.Array.isArray(object?.annotations)
        ? object.annotations.map((e: any) => Annotation.fromJSON(e))
        : [],
      metadata: isSet(object.metadata) ? Metadata.fromJSON(object.metadata) : undefined,
      topology: isSet(object.topology) ? fabricTopologyFromJSON(object.topology) : 0,
      templateId: isSet(object.templateId) ? globalThis.String(object.templateId) : "",
      entLevel: isSet(object.entLevel) ? entitlementLevelFromJSON(object.entLevel) : 0,
    };
  },

  toJSON(message: Fabric): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.location !== "") {
      obj.location = message.location;
    }
    if (message.address !== "") {
      obj.address = message.address;
    }
    if (message.city !== "") {
      obj.city = message.city;
    }
    if (message.country !== "") {
      obj.country = message.country;
    }
    if (message.labels?.length) {
      obj.labels = message.labels;
    }
    if (message.annotations?.length) {
      obj.annotations = message.annotations.map((e) => Annotation.toJSON(e));
    }
    if (message.metadata !== undefined) {
      obj.metadata = Metadata.toJSON(message.metadata);
    }
    if (message.topology !== 0) {
      obj.topology = fabricTopologyToJSON(message.topology);
    }
    if (message.templateId !== "") {
      obj.templateId = message.templateId;
    }
    if (message.entLevel !== 0) {
      obj.entLevel = entitlementLevelToJSON(message.entLevel);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Fabric>, I>>(base?: I): Fabric {
    return Fabric.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Fabric>, I>>(object: I): Fabric {
    const message = createBaseFabric();
    message.fabricId = object.fabricId ?? "";
    message.name = object.name ?? "";
    message.description = object.description ?? "";
    message.location = object.location ?? "";
    message.address = object.address ?? "";
    message.city = object.city ?? "";
    message.country = object.country ?? "";
    message.labels = object.labels?.map((e) => e) || [];
    message.annotations = object.annotations?.map((e) => Annotation.fromPartial(e)) || [];
    message.metadata = (object.metadata !== undefined && object.metadata !== null)
      ? Metadata.fromPartial(object.metadata)
      : undefined;
    message.topology = object.topology ?? 0;
    message.templateId = object.templateId ?? "";
    message.entLevel = object.entLevel ?? 0;
    return message;
  },
};

function createBaseGetFabricTemplatesRequest(): GetFabricTemplatesRequest {
  return {
    templateType: [],
    includeTemplateSummary: false,
    includeTemplateTagSummary: false,
    includeTagsPerTemplate: false,
    gpuCount: 0,
    deviceModelName: [],
    portSpeed: [],
    topologyArch: [],
    property: [],
    featureFlag: [],
    switchModelName: [],
  };
}

export const GetFabricTemplatesRequest: MessageFns<GetFabricTemplatesRequest> = {
  encode(message: GetFabricTemplatesRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    writer.uint32(10).fork();
    for (const v of message.templateType) {
      writer.int32(v);
    }
    writer.join();
    if (message.includeTemplateSummary !== false) {
      writer.uint32(16).bool(message.includeTemplateSummary);
    }
    if (message.includeTemplateTagSummary !== false) {
      writer.uint32(24).bool(message.includeTemplateTagSummary);
    }
    if (message.includeTagsPerTemplate !== false) {
      writer.uint32(32).bool(message.includeTagsPerTemplate);
    }
    if (message.gpuCount !== 0) {
      writer.uint32(40).uint32(message.gpuCount);
    }
    for (const v of message.deviceModelName) {
      writer.uint32(50).string(v!);
    }
    for (const v of message.portSpeed) {
      writer.uint32(58).string(v!);
    }
    for (const v of message.topologyArch) {
      writer.uint32(66).string(v!);
    }
    for (const v of message.property) {
      writer.uint32(74).string(v!);
    }
    for (const v of message.featureFlag) {
      writer.uint32(82).string(v!);
    }
    for (const v of message.switchModelName) {
      writer.uint32(90).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetFabricTemplatesRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetFabricTemplatesRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag === 8) {
            message.templateType.push(reader.int32() as any);

            continue;
          }

          if (tag === 10) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.templateType.push(reader.int32() as any);
            }

            continue;
          }

          break;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.includeTemplateSummary = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.includeTemplateTagSummary = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.includeTagsPerTemplate = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.gpuCount = reader.uint32();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.deviceModelName.push(reader.string());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.portSpeed.push(reader.string());
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.topologyArch.push(reader.string());
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.property.push(reader.string());
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.featureFlag.push(reader.string());
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.switchModelName.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetFabricTemplatesRequest {
    return {
      templateType: globalThis.Array.isArray(object?.templateType)
        ? object.templateType.map((e: any) => fabricTemplateTypeFromJSON(e))
        : [],
      includeTemplateSummary: isSet(object.includeTemplateSummary)
        ? globalThis.Boolean(object.includeTemplateSummary)
        : false,
      includeTemplateTagSummary: isSet(object.includeTemplateTagSummary)
        ? globalThis.Boolean(object.includeTemplateTagSummary)
        : false,
      includeTagsPerTemplate: isSet(object.includeTagsPerTemplate)
        ? globalThis.Boolean(object.includeTagsPerTemplate)
        : false,
      gpuCount: isSet(object.gpuCount) ? globalThis.Number(object.gpuCount) : 0,
      deviceModelName: globalThis.Array.isArray(object?.deviceModelName)
        ? object.deviceModelName.map((e: any) => globalThis.String(e))
        : [],
      portSpeed: globalThis.Array.isArray(object?.portSpeed)
        ? object.portSpeed.map((e: any) => globalThis.String(e))
        : [],
      topologyArch: globalThis.Array.isArray(object?.topologyArch)
        ? object.topologyArch.map((e: any) => globalThis.String(e))
        : [],
      property: globalThis.Array.isArray(object?.property) ? object.property.map((e: any) => globalThis.String(e)) : [],
      featureFlag: globalThis.Array.isArray(object?.featureFlag)
        ? object.featureFlag.map((e: any) => globalThis.String(e))
        : [],
      switchModelName: globalThis.Array.isArray(object?.switchModelName)
        ? object.switchModelName.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: GetFabricTemplatesRequest): unknown {
    const obj: any = {};
    if (message.templateType?.length) {
      obj.templateType = message.templateType.map((e) => fabricTemplateTypeToJSON(e));
    }
    if (message.includeTemplateSummary !== false) {
      obj.includeTemplateSummary = message.includeTemplateSummary;
    }
    if (message.includeTemplateTagSummary !== false) {
      obj.includeTemplateTagSummary = message.includeTemplateTagSummary;
    }
    if (message.includeTagsPerTemplate !== false) {
      obj.includeTagsPerTemplate = message.includeTagsPerTemplate;
    }
    if (message.gpuCount !== 0) {
      obj.gpuCount = Math.round(message.gpuCount);
    }
    if (message.deviceModelName?.length) {
      obj.deviceModelName = message.deviceModelName;
    }
    if (message.portSpeed?.length) {
      obj.portSpeed = message.portSpeed;
    }
    if (message.topologyArch?.length) {
      obj.topologyArch = message.topologyArch;
    }
    if (message.property?.length) {
      obj.property = message.property;
    }
    if (message.featureFlag?.length) {
      obj.featureFlag = message.featureFlag;
    }
    if (message.switchModelName?.length) {
      obj.switchModelName = message.switchModelName;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetFabricTemplatesRequest>, I>>(base?: I): GetFabricTemplatesRequest {
    return GetFabricTemplatesRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetFabricTemplatesRequest>, I>>(object: I): GetFabricTemplatesRequest {
    const message = createBaseGetFabricTemplatesRequest();
    message.templateType = object.templateType?.map((e) => e) || [];
    message.includeTemplateSummary = object.includeTemplateSummary ?? false;
    message.includeTemplateTagSummary = object.includeTemplateTagSummary ?? false;
    message.includeTagsPerTemplate = object.includeTagsPerTemplate ?? false;
    message.gpuCount = object.gpuCount ?? 0;
    message.deviceModelName = object.deviceModelName?.map((e) => e) || [];
    message.portSpeed = object.portSpeed?.map((e) => e) || [];
    message.topologyArch = object.topologyArch?.map((e) => e) || [];
    message.property = object.property?.map((e) => e) || [];
    message.featureFlag = object.featureFlag?.map((e) => e) || [];
    message.switchModelName = object.switchModelName?.map((e) => e) || [];
    return message;
  },
};

function createBaseGetFabricTemplatesResponse(): GetFabricTemplatesResponse {
  return { templates: [], templateTagSummary: undefined };
}

export const GetFabricTemplatesResponse: MessageFns<GetFabricTemplatesResponse> = {
  encode(message: GetFabricTemplatesResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.templates) {
      FabricBlueprintTemplate.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.templateTagSummary !== undefined) {
      FabricTemplateFilters.encode(message.templateTagSummary, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetFabricTemplatesResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetFabricTemplatesResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.templates.push(FabricBlueprintTemplate.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.templateTagSummary = FabricTemplateFilters.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetFabricTemplatesResponse {
    return {
      templates: globalThis.Array.isArray(object?.templates)
        ? object.templates.map((e: any) => FabricBlueprintTemplate.fromJSON(e))
        : [],
      templateTagSummary: isSet(object.templateTagSummary)
        ? FabricTemplateFilters.fromJSON(object.templateTagSummary)
        : undefined,
    };
  },

  toJSON(message: GetFabricTemplatesResponse): unknown {
    const obj: any = {};
    if (message.templates?.length) {
      obj.templates = message.templates.map((e) => FabricBlueprintTemplate.toJSON(e));
    }
    if (message.templateTagSummary !== undefined) {
      obj.templateTagSummary = FabricTemplateFilters.toJSON(message.templateTagSummary);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetFabricTemplatesResponse>, I>>(base?: I): GetFabricTemplatesResponse {
    return GetFabricTemplatesResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetFabricTemplatesResponse>, I>>(object: I): GetFabricTemplatesResponse {
    const message = createBaseGetFabricTemplatesResponse();
    message.templates = object.templates?.map((e) => FabricBlueprintTemplate.fromPartial(e)) || [];
    message.templateTagSummary = (object.templateTagSummary !== undefined && object.templateTagSummary !== null)
      ? FabricTemplateFilters.fromPartial(object.templateTagSummary)
      : undefined;
    return message;
  },
};

function createBaseGetFabricTemplateRequest(): GetFabricTemplateRequest {
  return { templateId: "", includeExample: false, includeTemplateSummary: false };
}

export const GetFabricTemplateRequest: MessageFns<GetFabricTemplateRequest> = {
  encode(message: GetFabricTemplateRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.templateId !== "") {
      writer.uint32(10).string(message.templateId);
    }
    if (message.includeExample !== false) {
      writer.uint32(16).bool(message.includeExample);
    }
    if (message.includeTemplateSummary !== false) {
      writer.uint32(24).bool(message.includeTemplateSummary);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetFabricTemplateRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetFabricTemplateRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.templateId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.includeExample = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.includeTemplateSummary = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetFabricTemplateRequest {
    return {
      templateId: isSet(object.templateId) ? globalThis.String(object.templateId) : "",
      includeExample: isSet(object.includeExample) ? globalThis.Boolean(object.includeExample) : false,
      includeTemplateSummary: isSet(object.includeTemplateSummary)
        ? globalThis.Boolean(object.includeTemplateSummary)
        : false,
    };
  },

  toJSON(message: GetFabricTemplateRequest): unknown {
    const obj: any = {};
    if (message.templateId !== "") {
      obj.templateId = message.templateId;
    }
    if (message.includeExample !== false) {
      obj.includeExample = message.includeExample;
    }
    if (message.includeTemplateSummary !== false) {
      obj.includeTemplateSummary = message.includeTemplateSummary;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetFabricTemplateRequest>, I>>(base?: I): GetFabricTemplateRequest {
    return GetFabricTemplateRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetFabricTemplateRequest>, I>>(object: I): GetFabricTemplateRequest {
    const message = createBaseGetFabricTemplateRequest();
    message.templateId = object.templateId ?? "";
    message.includeExample = object.includeExample ?? false;
    message.includeTemplateSummary = object.includeTemplateSummary ?? false;
    return message;
  },
};

function createBaseGetFabricTemplateResponse(): GetFabricTemplateResponse {
  return { template: undefined, exampleFabric: undefined };
}

export const GetFabricTemplateResponse: MessageFns<GetFabricTemplateResponse> = {
  encode(message: GetFabricTemplateResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.template !== undefined) {
      FabricBlueprintTemplate.encode(message.template, writer.uint32(10).fork()).join();
    }
    if (message.exampleFabric !== undefined) {
      FabricConfig.encode(message.exampleFabric, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetFabricTemplateResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetFabricTemplateResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.template = FabricBlueprintTemplate.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.exampleFabric = FabricConfig.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetFabricTemplateResponse {
    return {
      template: isSet(object.template) ? FabricBlueprintTemplate.fromJSON(object.template) : undefined,
      exampleFabric: isSet(object.exampleFabric) ? FabricConfig.fromJSON(object.exampleFabric) : undefined,
    };
  },

  toJSON(message: GetFabricTemplateResponse): unknown {
    const obj: any = {};
    if (message.template !== undefined) {
      obj.template = FabricBlueprintTemplate.toJSON(message.template);
    }
    if (message.exampleFabric !== undefined) {
      obj.exampleFabric = FabricConfig.toJSON(message.exampleFabric);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetFabricTemplateResponse>, I>>(base?: I): GetFabricTemplateResponse {
    return GetFabricTemplateResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetFabricTemplateResponse>, I>>(object: I): GetFabricTemplateResponse {
    const message = createBaseGetFabricTemplateResponse();
    message.template = (object.template !== undefined && object.template !== null)
      ? FabricBlueprintTemplate.fromPartial(object.template)
      : undefined;
    message.exampleFabric = (object.exampleFabric !== undefined && object.exampleFabric !== null)
      ? FabricConfig.fromPartial(object.exampleFabric)
      : undefined;
    return message;
  },
};

function createBaseGetCablingPlanRequest(): GetCablingPlanRequest {
  return {
    fabricId: "",
    candidate: "",
    groupName: [],
    groupId: [],
    railId: [],
    railName: [],
    nodeName: [],
    nodeId: [],
    excludeObservedStateDataInResponse: false,
  };
}

export const GetCablingPlanRequest: MessageFns<GetCablingPlanRequest> = {
  encode(message: GetCablingPlanRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.candidate !== "") {
      writer.uint32(18).string(message.candidate);
    }
    for (const v of message.groupName) {
      writer.uint32(26).string(v!);
    }
    for (const v of message.groupId) {
      writer.uint32(34).string(v!);
    }
    for (const v of message.railId) {
      writer.uint32(42).string(v!);
    }
    for (const v of message.railName) {
      writer.uint32(50).string(v!);
    }
    for (const v of message.nodeName) {
      writer.uint32(58).string(v!);
    }
    for (const v of message.nodeId) {
      writer.uint32(66).string(v!);
    }
    if (message.excludeObservedStateDataInResponse !== false) {
      writer.uint32(72).bool(message.excludeObservedStateDataInResponse);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetCablingPlanRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetCablingPlanRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.candidate = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.groupName.push(reader.string());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.groupId.push(reader.string());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.railId.push(reader.string());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.railName.push(reader.string());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.nodeName.push(reader.string());
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.nodeId.push(reader.string());
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.excludeObservedStateDataInResponse = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetCablingPlanRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      candidate: isSet(object.candidate) ? globalThis.String(object.candidate) : "",
      groupName: globalThis.Array.isArray(object?.groupName)
        ? object.groupName.map((e: any) => globalThis.String(e))
        : [],
      groupId: globalThis.Array.isArray(object?.groupId) ? object.groupId.map((e: any) => globalThis.String(e)) : [],
      railId: globalThis.Array.isArray(object?.railId) ? object.railId.map((e: any) => globalThis.String(e)) : [],
      railName: globalThis.Array.isArray(object?.railName) ? object.railName.map((e: any) => globalThis.String(e)) : [],
      nodeName: globalThis.Array.isArray(object?.nodeName) ? object.nodeName.map((e: any) => globalThis.String(e)) : [],
      nodeId: globalThis.Array.isArray(object?.nodeId) ? object.nodeId.map((e: any) => globalThis.String(e)) : [],
      excludeObservedStateDataInResponse: isSet(object.excludeObservedStateDataInResponse)
        ? globalThis.Boolean(object.excludeObservedStateDataInResponse)
        : false,
    };
  },

  toJSON(message: GetCablingPlanRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.candidate !== "") {
      obj.candidate = message.candidate;
    }
    if (message.groupName?.length) {
      obj.groupName = message.groupName;
    }
    if (message.groupId?.length) {
      obj.groupId = message.groupId;
    }
    if (message.railId?.length) {
      obj.railId = message.railId;
    }
    if (message.railName?.length) {
      obj.railName = message.railName;
    }
    if (message.nodeName?.length) {
      obj.nodeName = message.nodeName;
    }
    if (message.nodeId?.length) {
      obj.nodeId = message.nodeId;
    }
    if (message.excludeObservedStateDataInResponse !== false) {
      obj.excludeObservedStateDataInResponse = message.excludeObservedStateDataInResponse;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetCablingPlanRequest>, I>>(base?: I): GetCablingPlanRequest {
    return GetCablingPlanRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetCablingPlanRequest>, I>>(object: I): GetCablingPlanRequest {
    const message = createBaseGetCablingPlanRequest();
    message.fabricId = object.fabricId ?? "";
    message.candidate = object.candidate ?? "";
    message.groupName = object.groupName?.map((e) => e) || [];
    message.groupId = object.groupId?.map((e) => e) || [];
    message.railId = object.railId?.map((e) => e) || [];
    message.railName = object.railName?.map((e) => e) || [];
    message.nodeName = object.nodeName?.map((e) => e) || [];
    message.nodeId = object.nodeId?.map((e) => e) || [];
    message.excludeObservedStateDataInResponse = object.excludeObservedStateDataInResponse ?? false;
    return message;
  },
};

function createBaseGetCablingPlanResponse(): GetCablingPlanResponse {
  return { connections: [], observedConnections: [] };
}

export const GetCablingPlanResponse: MessageFns<GetCablingPlanResponse> = {
  encode(message: GetCablingPlanResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.connections) {
      CablingConnection.encode(v!, writer.uint32(26).fork()).join();
    }
    for (const v of message.observedConnections) {
      CablingConnection.encode(v!, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetCablingPlanResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetCablingPlanResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.connections.push(CablingConnection.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.observedConnections.push(CablingConnection.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetCablingPlanResponse {
    return {
      connections: globalThis.Array.isArray(object?.connections)
        ? object.connections.map((e: any) => CablingConnection.fromJSON(e))
        : [],
      observedConnections: globalThis.Array.isArray(object?.observedConnections)
        ? object.observedConnections.map((e: any) => CablingConnection.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GetCablingPlanResponse): unknown {
    const obj: any = {};
    if (message.connections?.length) {
      obj.connections = message.connections.map((e) => CablingConnection.toJSON(e));
    }
    if (message.observedConnections?.length) {
      obj.observedConnections = message.observedConnections.map((e) => CablingConnection.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetCablingPlanResponse>, I>>(base?: I): GetCablingPlanResponse {
    return GetCablingPlanResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetCablingPlanResponse>, I>>(object: I): GetCablingPlanResponse {
    const message = createBaseGetCablingPlanResponse();
    message.connections = object.connections?.map((e) => CablingConnection.fromPartial(e)) || [];
    message.observedConnections = object.observedConnections?.map((e) => CablingConnection.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGenerateCablingPlanRequest(): GenerateCablingPlanRequest {
  return {
    fabricId: "",
    design: undefined,
    dryRun: false,
    failFast: false,
    includeCablingPlan: false,
    includeExceptions: false,
    excludeObservedStateDataInResponse: false,
  };
}

export const GenerateCablingPlanRequest: MessageFns<GenerateCablingPlanRequest> = {
  encode(message: GenerateCablingPlanRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.design !== undefined) {
      FabricDesign.encode(message.design, writer.uint32(18).fork()).join();
    }
    if (message.dryRun !== false) {
      writer.uint32(24).bool(message.dryRun);
    }
    if (message.failFast !== false) {
      writer.uint32(32).bool(message.failFast);
    }
    if (message.includeCablingPlan !== false) {
      writer.uint32(40).bool(message.includeCablingPlan);
    }
    if (message.includeExceptions !== false) {
      writer.uint32(48).bool(message.includeExceptions);
    }
    if (message.excludeObservedStateDataInResponse !== false) {
      writer.uint32(56).bool(message.excludeObservedStateDataInResponse);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GenerateCablingPlanRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGenerateCablingPlanRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.design = FabricDesign.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.dryRun = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.failFast = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.includeCablingPlan = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.includeExceptions = reader.bool();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.excludeObservedStateDataInResponse = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GenerateCablingPlanRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      design: isSet(object.design) ? FabricDesign.fromJSON(object.design) : undefined,
      dryRun: isSet(object.dryRun) ? globalThis.Boolean(object.dryRun) : false,
      failFast: isSet(object.failFast) ? globalThis.Boolean(object.failFast) : false,
      includeCablingPlan: isSet(object.includeCablingPlan) ? globalThis.Boolean(object.includeCablingPlan) : false,
      includeExceptions: isSet(object.includeExceptions) ? globalThis.Boolean(object.includeExceptions) : false,
      excludeObservedStateDataInResponse: isSet(object.excludeObservedStateDataInResponse)
        ? globalThis.Boolean(object.excludeObservedStateDataInResponse)
        : false,
    };
  },

  toJSON(message: GenerateCablingPlanRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.design !== undefined) {
      obj.design = FabricDesign.toJSON(message.design);
    }
    if (message.dryRun !== false) {
      obj.dryRun = message.dryRun;
    }
    if (message.failFast !== false) {
      obj.failFast = message.failFast;
    }
    if (message.includeCablingPlan !== false) {
      obj.includeCablingPlan = message.includeCablingPlan;
    }
    if (message.includeExceptions !== false) {
      obj.includeExceptions = message.includeExceptions;
    }
    if (message.excludeObservedStateDataInResponse !== false) {
      obj.excludeObservedStateDataInResponse = message.excludeObservedStateDataInResponse;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GenerateCablingPlanRequest>, I>>(base?: I): GenerateCablingPlanRequest {
    return GenerateCablingPlanRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GenerateCablingPlanRequest>, I>>(object: I): GenerateCablingPlanRequest {
    const message = createBaseGenerateCablingPlanRequest();
    message.fabricId = object.fabricId ?? "";
    message.design = (object.design !== undefined && object.design !== null)
      ? FabricDesign.fromPartial(object.design)
      : undefined;
    message.dryRun = object.dryRun ?? false;
    message.failFast = object.failFast ?? false;
    message.includeCablingPlan = object.includeCablingPlan ?? false;
    message.includeExceptions = object.includeExceptions ?? false;
    message.excludeObservedStateDataInResponse = object.excludeObservedStateDataInResponse ?? false;
    return message;
  },
};

function createBaseGenerateCablingPlanResponse(): GenerateCablingPlanResponse {
  return { fabricId: "", connections: [], execStatus: 0, exceptions: [], observedConnections: [] };
}

export const GenerateCablingPlanResponse: MessageFns<GenerateCablingPlanResponse> = {
  encode(message: GenerateCablingPlanResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    for (const v of message.connections) {
      CablingConnection.encode(v!, writer.uint32(18).fork()).join();
    }
    if (message.execStatus !== 0) {
      writer.uint32(24).int32(message.execStatus);
    }
    for (const v of message.exceptions) {
      RuleExecutionException.encode(v!, writer.uint32(34).fork()).join();
    }
    for (const v of message.observedConnections) {
      CablingConnection.encode(v!, writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GenerateCablingPlanResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGenerateCablingPlanResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.connections.push(CablingConnection.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.execStatus = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.exceptions.push(RuleExecutionException.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.observedConnections.push(CablingConnection.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GenerateCablingPlanResponse {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      connections: globalThis.Array.isArray(object?.connections)
        ? object.connections.map((e: any) => CablingConnection.fromJSON(e))
        : [],
      execStatus: isSet(object.execStatus) ? cablingPlanStatusFromJSON(object.execStatus) : 0,
      exceptions: globalThis.Array.isArray(object?.exceptions)
        ? object.exceptions.map((e: any) => RuleExecutionException.fromJSON(e))
        : [],
      observedConnections: globalThis.Array.isArray(object?.observedConnections)
        ? object.observedConnections.map((e: any) => CablingConnection.fromJSON(e))
        : [],
    };
  },

  toJSON(message: GenerateCablingPlanResponse): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.connections?.length) {
      obj.connections = message.connections.map((e) => CablingConnection.toJSON(e));
    }
    if (message.execStatus !== 0) {
      obj.execStatus = cablingPlanStatusToJSON(message.execStatus);
    }
    if (message.exceptions?.length) {
      obj.exceptions = message.exceptions.map((e) => RuleExecutionException.toJSON(e));
    }
    if (message.observedConnections?.length) {
      obj.observedConnections = message.observedConnections.map((e) => CablingConnection.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GenerateCablingPlanResponse>, I>>(base?: I): GenerateCablingPlanResponse {
    return GenerateCablingPlanResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GenerateCablingPlanResponse>, I>>(object: I): GenerateCablingPlanResponse {
    const message = createBaseGenerateCablingPlanResponse();
    message.fabricId = object.fabricId ?? "";
    message.connections = object.connections?.map((e) => CablingConnection.fromPartial(e)) || [];
    message.execStatus = object.execStatus ?? 0;
    message.exceptions = object.exceptions?.map((e) => RuleExecutionException.fromPartial(e)) || [];
    message.observedConnections = object.observedConnections?.map((e) => CablingConnection.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetAllFabricsRequest(): GetAllFabricsRequest {
  return { fabricId: [], candidate: "", includeMetadata: false, max: 0, cursor: "" };
}

export const GetAllFabricsRequest: MessageFns<GetAllFabricsRequest> = {
  encode(message: GetAllFabricsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.fabricId) {
      writer.uint32(10).string(v!);
    }
    if (message.candidate !== "") {
      writer.uint32(18).string(message.candidate);
    }
    if (message.includeMetadata !== false) {
      writer.uint32(24).bool(message.includeMetadata);
    }
    if (message.max !== 0) {
      writer.uint32(32).uint32(message.max);
    }
    if (message.cursor !== "") {
      writer.uint32(42).string(message.cursor);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetAllFabricsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetAllFabricsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId.push(reader.string());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.candidate = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.includeMetadata = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.max = reader.uint32();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.cursor = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetAllFabricsRequest {
    return {
      fabricId: globalThis.Array.isArray(object?.fabricId) ? object.fabricId.map((e: any) => globalThis.String(e)) : [],
      candidate: isSet(object.candidate) ? globalThis.String(object.candidate) : "",
      includeMetadata: isSet(object.includeMetadata) ? globalThis.Boolean(object.includeMetadata) : false,
      max: isSet(object.max) ? globalThis.Number(object.max) : 0,
      cursor: isSet(object.cursor) ? globalThis.String(object.cursor) : "",
    };
  },

  toJSON(message: GetAllFabricsRequest): unknown {
    const obj: any = {};
    if (message.fabricId?.length) {
      obj.fabricId = message.fabricId;
    }
    if (message.candidate !== "") {
      obj.candidate = message.candidate;
    }
    if (message.includeMetadata !== false) {
      obj.includeMetadata = message.includeMetadata;
    }
    if (message.max !== 0) {
      obj.max = Math.round(message.max);
    }
    if (message.cursor !== "") {
      obj.cursor = message.cursor;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetAllFabricsRequest>, I>>(base?: I): GetAllFabricsRequest {
    return GetAllFabricsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetAllFabricsRequest>, I>>(object: I): GetAllFabricsRequest {
    const message = createBaseGetAllFabricsRequest();
    message.fabricId = object.fabricId?.map((e) => e) || [];
    message.candidate = object.candidate ?? "";
    message.includeMetadata = object.includeMetadata ?? false;
    message.max = object.max ?? 0;
    message.cursor = object.cursor ?? "";
    return message;
  },
};

function createBaseGetAllFabricsResponse(): GetAllFabricsResponse {
  return { fabrics: [], cursor: "" };
}

export const GetAllFabricsResponse: MessageFns<GetAllFabricsResponse> = {
  encode(message: GetAllFabricsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.fabrics) {
      Fabric.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.cursor !== "") {
      writer.uint32(18).string(message.cursor);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetAllFabricsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetAllFabricsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabrics.push(Fabric.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.cursor = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetAllFabricsResponse {
    return {
      fabrics: globalThis.Array.isArray(object?.fabrics) ? object.fabrics.map((e: any) => Fabric.fromJSON(e)) : [],
      cursor: isSet(object.cursor) ? globalThis.String(object.cursor) : "",
    };
  },

  toJSON(message: GetAllFabricsResponse): unknown {
    const obj: any = {};
    if (message.fabrics?.length) {
      obj.fabrics = message.fabrics.map((e) => Fabric.toJSON(e));
    }
    if (message.cursor !== "") {
      obj.cursor = message.cursor;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetAllFabricsResponse>, I>>(base?: I): GetAllFabricsResponse {
    return GetAllFabricsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetAllFabricsResponse>, I>>(object: I): GetAllFabricsResponse {
    const message = createBaseGetAllFabricsResponse();
    message.fabrics = object.fabrics?.map((e) => Fabric.fromPartial(e)) || [];
    message.cursor = object.cursor ?? "";
    return message;
  },
};

function createBaseGetFabricRequest(): GetFabricRequest {
  return { fabricId: "", candidate: "", includeMetadata: false };
}

export const GetFabricRequest: MessageFns<GetFabricRequest> = {
  encode(message: GetFabricRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.candidate !== "") {
      writer.uint32(18).string(message.candidate);
    }
    if (message.includeMetadata !== false) {
      writer.uint32(24).bool(message.includeMetadata);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetFabricRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetFabricRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.candidate = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.includeMetadata = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetFabricRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      candidate: isSet(object.candidate) ? globalThis.String(object.candidate) : "",
      includeMetadata: isSet(object.includeMetadata) ? globalThis.Boolean(object.includeMetadata) : false,
    };
  },

  toJSON(message: GetFabricRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.candidate !== "") {
      obj.candidate = message.candidate;
    }
    if (message.includeMetadata !== false) {
      obj.includeMetadata = message.includeMetadata;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetFabricRequest>, I>>(base?: I): GetFabricRequest {
    return GetFabricRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetFabricRequest>, I>>(object: I): GetFabricRequest {
    const message = createBaseGetFabricRequest();
    message.fabricId = object.fabricId ?? "";
    message.candidate = object.candidate ?? "";
    message.includeMetadata = object.includeMetadata ?? false;
    return message;
  },
};

function createBaseAddFabricsRequest(): AddFabricsRequest {
  return { fabrics: [] };
}

export const AddFabricsRequest: MessageFns<AddFabricsRequest> = {
  encode(message: AddFabricsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.fabrics) {
      Fabric.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AddFabricsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAddFabricsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabrics.push(Fabric.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AddFabricsRequest {
    return {
      fabrics: globalThis.Array.isArray(object?.fabrics) ? object.fabrics.map((e: any) => Fabric.fromJSON(e)) : [],
    };
  },

  toJSON(message: AddFabricsRequest): unknown {
    const obj: any = {};
    if (message.fabrics?.length) {
      obj.fabrics = message.fabrics.map((e) => Fabric.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AddFabricsRequest>, I>>(base?: I): AddFabricsRequest {
    return AddFabricsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AddFabricsRequest>, I>>(object: I): AddFabricsRequest {
    const message = createBaseAddFabricsRequest();
    message.fabrics = object.fabrics?.map((e) => Fabric.fromPartial(e)) || [];
    return message;
  },
};

function createBaseAddFabricsResponse(): AddFabricsResponse {
  return { fabrics: [] };
}

export const AddFabricsResponse: MessageFns<AddFabricsResponse> = {
  encode(message: AddFabricsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.fabrics) {
      Fabric.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AddFabricsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAddFabricsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabrics.push(Fabric.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AddFabricsResponse {
    return {
      fabrics: globalThis.Array.isArray(object?.fabrics) ? object.fabrics.map((e: any) => Fabric.fromJSON(e)) : [],
    };
  },

  toJSON(message: AddFabricsResponse): unknown {
    const obj: any = {};
    if (message.fabrics?.length) {
      obj.fabrics = message.fabrics.map((e) => Fabric.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AddFabricsResponse>, I>>(base?: I): AddFabricsResponse {
    return AddFabricsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AddFabricsResponse>, I>>(object: I): AddFabricsResponse {
    const message = createBaseAddFabricsResponse();
    message.fabrics = object.fabrics?.map((e) => Fabric.fromPartial(e)) || [];
    return message;
  },
};

function createBaseAddFabricWithDesignRequest(): AddFabricWithDesignRequest {
  return { fabric: undefined, design: undefined, templateId: "", sourceFabricId: "", discoveredNodeDeviceBindings: [] };
}

export const AddFabricWithDesignRequest: MessageFns<AddFabricWithDesignRequest> = {
  encode(message: AddFabricWithDesignRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabric !== undefined) {
      Fabric.encode(message.fabric, writer.uint32(10).fork()).join();
    }
    if (message.design !== undefined) {
      FabricDesign.encode(message.design, writer.uint32(18).fork()).join();
    }
    if (message.templateId !== "") {
      writer.uint32(26).string(message.templateId);
    }
    if (message.sourceFabricId !== "") {
      writer.uint32(34).string(message.sourceFabricId);
    }
    for (const v of message.discoveredNodeDeviceBindings) {
      DesignNodeData.encode(v!, writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AddFabricWithDesignRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAddFabricWithDesignRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabric = Fabric.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.design = FabricDesign.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.templateId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.sourceFabricId = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.discoveredNodeDeviceBindings.push(DesignNodeData.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AddFabricWithDesignRequest {
    return {
      fabric: isSet(object.fabric) ? Fabric.fromJSON(object.fabric) : undefined,
      design: isSet(object.design) ? FabricDesign.fromJSON(object.design) : undefined,
      templateId: isSet(object.templateId) ? globalThis.String(object.templateId) : "",
      sourceFabricId: isSet(object.sourceFabricId) ? globalThis.String(object.sourceFabricId) : "",
      discoveredNodeDeviceBindings: globalThis.Array.isArray(object?.discoveredNodeDeviceBindings)
        ? object.discoveredNodeDeviceBindings.map((e: any) => DesignNodeData.fromJSON(e))
        : [],
    };
  },

  toJSON(message: AddFabricWithDesignRequest): unknown {
    const obj: any = {};
    if (message.fabric !== undefined) {
      obj.fabric = Fabric.toJSON(message.fabric);
    }
    if (message.design !== undefined) {
      obj.design = FabricDesign.toJSON(message.design);
    }
    if (message.templateId !== "") {
      obj.templateId = message.templateId;
    }
    if (message.sourceFabricId !== "") {
      obj.sourceFabricId = message.sourceFabricId;
    }
    if (message.discoveredNodeDeviceBindings?.length) {
      obj.discoveredNodeDeviceBindings = message.discoveredNodeDeviceBindings.map((e) => DesignNodeData.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AddFabricWithDesignRequest>, I>>(base?: I): AddFabricWithDesignRequest {
    return AddFabricWithDesignRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AddFabricWithDesignRequest>, I>>(object: I): AddFabricWithDesignRequest {
    const message = createBaseAddFabricWithDesignRequest();
    message.fabric = (object.fabric !== undefined && object.fabric !== null)
      ? Fabric.fromPartial(object.fabric)
      : undefined;
    message.design = (object.design !== undefined && object.design !== null)
      ? FabricDesign.fromPartial(object.design)
      : undefined;
    message.templateId = object.templateId ?? "";
    message.sourceFabricId = object.sourceFabricId ?? "";
    message.discoveredNodeDeviceBindings =
      object.discoveredNodeDeviceBindings?.map((e) => DesignNodeData.fromPartial(e)) || [];
    return message;
  },
};

function createBaseAddFabricWithDesignResponse(): AddFabricWithDesignResponse {
  return { fabric: undefined };
}

export const AddFabricWithDesignResponse: MessageFns<AddFabricWithDesignResponse> = {
  encode(message: AddFabricWithDesignResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabric !== undefined) {
      Fabric.encode(message.fabric, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AddFabricWithDesignResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAddFabricWithDesignResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabric = Fabric.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AddFabricWithDesignResponse {
    return { fabric: isSet(object.fabric) ? Fabric.fromJSON(object.fabric) : undefined };
  },

  toJSON(message: AddFabricWithDesignResponse): unknown {
    const obj: any = {};
    if (message.fabric !== undefined) {
      obj.fabric = Fabric.toJSON(message.fabric);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AddFabricWithDesignResponse>, I>>(base?: I): AddFabricWithDesignResponse {
    return AddFabricWithDesignResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AddFabricWithDesignResponse>, I>>(object: I): AddFabricWithDesignResponse {
    const message = createBaseAddFabricWithDesignResponse();
    message.fabric = (object.fabric !== undefined && object.fabric !== null)
      ? Fabric.fromPartial(object.fabric)
      : undefined;
    return message;
  },
};

function createBaseUpdateFabricRequest(): UpdateFabricRequest {
  return { fabricId: "", fabric: undefined };
}

export const UpdateFabricRequest: MessageFns<UpdateFabricRequest> = {
  encode(message: UpdateFabricRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.fabric !== undefined) {
      Fabric.encode(message.fabric, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateFabricRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateFabricRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.fabric = Fabric.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateFabricRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      fabric: isSet(object.fabric) ? Fabric.fromJSON(object.fabric) : undefined,
    };
  },

  toJSON(message: UpdateFabricRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.fabric !== undefined) {
      obj.fabric = Fabric.toJSON(message.fabric);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateFabricRequest>, I>>(base?: I): UpdateFabricRequest {
    return UpdateFabricRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateFabricRequest>, I>>(object: I): UpdateFabricRequest {
    const message = createBaseUpdateFabricRequest();
    message.fabricId = object.fabricId ?? "";
    message.fabric = (object.fabric !== undefined && object.fabric !== null)
      ? Fabric.fromPartial(object.fabric)
      : undefined;
    return message;
  },
};

function createBaseUpdateFabricWithDesignRequest(): UpdateFabricWithDesignRequest {
  return { fabricId: "", fabric: undefined, design: undefined, discoveredNodeDeviceBindings: [] };
}

export const UpdateFabricWithDesignRequest: MessageFns<UpdateFabricWithDesignRequest> = {
  encode(message: UpdateFabricWithDesignRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.fabric !== undefined) {
      Fabric.encode(message.fabric, writer.uint32(18).fork()).join();
    }
    if (message.design !== undefined) {
      FabricDesign.encode(message.design, writer.uint32(26).fork()).join();
    }
    for (const v of message.discoveredNodeDeviceBindings) {
      DesignNodeData.encode(v!, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateFabricWithDesignRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateFabricWithDesignRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.fabric = Fabric.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.design = FabricDesign.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.discoveredNodeDeviceBindings.push(DesignNodeData.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateFabricWithDesignRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      fabric: isSet(object.fabric) ? Fabric.fromJSON(object.fabric) : undefined,
      design: isSet(object.design) ? FabricDesign.fromJSON(object.design) : undefined,
      discoveredNodeDeviceBindings: globalThis.Array.isArray(object?.discoveredNodeDeviceBindings)
        ? object.discoveredNodeDeviceBindings.map((e: any) => DesignNodeData.fromJSON(e))
        : [],
    };
  },

  toJSON(message: UpdateFabricWithDesignRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.fabric !== undefined) {
      obj.fabric = Fabric.toJSON(message.fabric);
    }
    if (message.design !== undefined) {
      obj.design = FabricDesign.toJSON(message.design);
    }
    if (message.discoveredNodeDeviceBindings?.length) {
      obj.discoveredNodeDeviceBindings = message.discoveredNodeDeviceBindings.map((e) => DesignNodeData.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateFabricWithDesignRequest>, I>>(base?: I): UpdateFabricWithDesignRequest {
    return UpdateFabricWithDesignRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateFabricWithDesignRequest>, I>>(
    object: I,
  ): UpdateFabricWithDesignRequest {
    const message = createBaseUpdateFabricWithDesignRequest();
    message.fabricId = object.fabricId ?? "";
    message.fabric = (object.fabric !== undefined && object.fabric !== null)
      ? Fabric.fromPartial(object.fabric)
      : undefined;
    message.design = (object.design !== undefined && object.design !== null)
      ? FabricDesign.fromPartial(object.design)
      : undefined;
    message.discoveredNodeDeviceBindings =
      object.discoveredNodeDeviceBindings?.map((e) => DesignNodeData.fromPartial(e)) || [];
    return message;
  },
};

function createBaseDeleteFabricRequest(): DeleteFabricRequest {
  return { fabricId: "" };
}

export const DeleteFabricRequest: MessageFns<DeleteFabricRequest> = {
  encode(message: DeleteFabricRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteFabricRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteFabricRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeleteFabricRequest {
    return { fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "" };
  },

  toJSON(message: DeleteFabricRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeleteFabricRequest>, I>>(base?: I): DeleteFabricRequest {
    return DeleteFabricRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeleteFabricRequest>, I>>(object: I): DeleteFabricRequest {
    const message = createBaseDeleteFabricRequest();
    message.fabricId = object.fabricId ?? "";
    return message;
  },
};

function createBaseGetFabricConnectionsRequest(): GetFabricConnectionsRequest {
  return { fabricId: "", candidate: "" };
}

export const GetFabricConnectionsRequest: MessageFns<GetFabricConnectionsRequest> = {
  encode(message: GetFabricConnectionsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.candidate !== "") {
      writer.uint32(18).string(message.candidate);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetFabricConnectionsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetFabricConnectionsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.candidate = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetFabricConnectionsRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      candidate: isSet(object.candidate) ? globalThis.String(object.candidate) : "",
    };
  },

  toJSON(message: GetFabricConnectionsRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.candidate !== "") {
      obj.candidate = message.candidate;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetFabricConnectionsRequest>, I>>(base?: I): GetFabricConnectionsRequest {
    return GetFabricConnectionsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetFabricConnectionsRequest>, I>>(object: I): GetFabricConnectionsRequest {
    const message = createBaseGetFabricConnectionsRequest();
    message.fabricId = object.fabricId ?? "";
    message.candidate = object.candidate ?? "";
    return message;
  },
};

function createBaseGetFabricConnectionRequest(): GetFabricConnectionRequest {
  return { fabricId: "", connectionId: "", candidate: "" };
}

export const GetFabricConnectionRequest: MessageFns<GetFabricConnectionRequest> = {
  encode(message: GetFabricConnectionRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.connectionId !== "") {
      writer.uint32(18).string(message.connectionId);
    }
    if (message.candidate !== "") {
      writer.uint32(26).string(message.candidate);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetFabricConnectionRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetFabricConnectionRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.connectionId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.candidate = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetFabricConnectionRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      connectionId: isSet(object.connectionId) ? globalThis.String(object.connectionId) : "",
      candidate: isSet(object.candidate) ? globalThis.String(object.candidate) : "",
    };
  },

  toJSON(message: GetFabricConnectionRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.connectionId !== "") {
      obj.connectionId = message.connectionId;
    }
    if (message.candidate !== "") {
      obj.candidate = message.candidate;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetFabricConnectionRequest>, I>>(base?: I): GetFabricConnectionRequest {
    return GetFabricConnectionRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetFabricConnectionRequest>, I>>(object: I): GetFabricConnectionRequest {
    const message = createBaseGetFabricConnectionRequest();
    message.fabricId = object.fabricId ?? "";
    message.connectionId = object.connectionId ?? "";
    message.candidate = object.candidate ?? "";
    return message;
  },
};

function createBaseDeleteFabricConnectionsRequest(): DeleteFabricConnectionsRequest {
  return { fabricId: "" };
}

export const DeleteFabricConnectionsRequest: MessageFns<DeleteFabricConnectionsRequest> = {
  encode(message: DeleteFabricConnectionsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteFabricConnectionsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteFabricConnectionsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeleteFabricConnectionsRequest {
    return { fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "" };
  },

  toJSON(message: DeleteFabricConnectionsRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeleteFabricConnectionsRequest>, I>>(base?: I): DeleteFabricConnectionsRequest {
    return DeleteFabricConnectionsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeleteFabricConnectionsRequest>, I>>(
    object: I,
  ): DeleteFabricConnectionsRequest {
    const message = createBaseDeleteFabricConnectionsRequest();
    message.fabricId = object.fabricId ?? "";
    return message;
  },
};

function createBaseDeleteFabricConnectionRequest(): DeleteFabricConnectionRequest {
  return { fabricId: "", connectionId: "" };
}

export const DeleteFabricConnectionRequest: MessageFns<DeleteFabricConnectionRequest> = {
  encode(message: DeleteFabricConnectionRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.connectionId !== "") {
      writer.uint32(18).string(message.connectionId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeleteFabricConnectionRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteFabricConnectionRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.connectionId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeleteFabricConnectionRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      connectionId: isSet(object.connectionId) ? globalThis.String(object.connectionId) : "",
    };
  },

  toJSON(message: DeleteFabricConnectionRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.connectionId !== "") {
      obj.connectionId = message.connectionId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeleteFabricConnectionRequest>, I>>(base?: I): DeleteFabricConnectionRequest {
    return DeleteFabricConnectionRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeleteFabricConnectionRequest>, I>>(
    object: I,
  ): DeleteFabricConnectionRequest {
    const message = createBaseDeleteFabricConnectionRequest();
    message.fabricId = object.fabricId ?? "";
    message.connectionId = object.connectionId ?? "";
    return message;
  },
};

function createBaseAddFabricConnectionsRequest(): AddFabricConnectionsRequest {
  return { fabricId: "", connections: [] };
}

export const AddFabricConnectionsRequest: MessageFns<AddFabricConnectionsRequest> = {
  encode(message: AddFabricConnectionsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    for (const v of message.connections) {
      PortConnection.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AddFabricConnectionsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAddFabricConnectionsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.connections.push(PortConnection.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AddFabricConnectionsRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      connections: globalThis.Array.isArray(object?.connections)
        ? object.connections.map((e: any) => PortConnection.fromJSON(e))
        : [],
    };
  },

  toJSON(message: AddFabricConnectionsRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.connections?.length) {
      obj.connections = message.connections.map((e) => PortConnection.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AddFabricConnectionsRequest>, I>>(base?: I): AddFabricConnectionsRequest {
    return AddFabricConnectionsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AddFabricConnectionsRequest>, I>>(object: I): AddFabricConnectionsRequest {
    const message = createBaseAddFabricConnectionsRequest();
    message.fabricId = object.fabricId ?? "";
    message.connections = object.connections?.map((e) => PortConnection.fromPartial(e)) || [];
    return message;
  },
};

function createBaseSetFabricConnectionsRequest(): SetFabricConnectionsRequest {
  return { fabricId: "", connections: [] };
}

export const SetFabricConnectionsRequest: MessageFns<SetFabricConnectionsRequest> = {
  encode(message: SetFabricConnectionsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    for (const v of message.connections) {
      PortConnection.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SetFabricConnectionsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetFabricConnectionsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.connections.push(PortConnection.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SetFabricConnectionsRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      connections: globalThis.Array.isArray(object?.connections)
        ? object.connections.map((e: any) => PortConnection.fromJSON(e))
        : [],
    };
  },

  toJSON(message: SetFabricConnectionsRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.connections?.length) {
      obj.connections = message.connections.map((e) => PortConnection.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SetFabricConnectionsRequest>, I>>(base?: I): SetFabricConnectionsRequest {
    return SetFabricConnectionsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetFabricConnectionsRequest>, I>>(object: I): SetFabricConnectionsRequest {
    const message = createBaseSetFabricConnectionsRequest();
    message.fabricId = object.fabricId ?? "";
    message.connections = object.connections?.map((e) => PortConnection.fromPartial(e)) || [];
    return message;
  },
};

function createBaseSetFabricConnectionRequest(): SetFabricConnectionRequest {
  return { fabricId: "", connectionId: "", connection: undefined };
}

export const SetFabricConnectionRequest: MessageFns<SetFabricConnectionRequest> = {
  encode(message: SetFabricConnectionRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.connectionId !== "") {
      writer.uint32(18).string(message.connectionId);
    }
    if (message.connection !== undefined) {
      PortConnection.encode(message.connection, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SetFabricConnectionRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetFabricConnectionRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.connectionId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.connection = PortConnection.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SetFabricConnectionRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      connectionId: isSet(object.connectionId) ? globalThis.String(object.connectionId) : "",
      connection: isSet(object.connection) ? PortConnection.fromJSON(object.connection) : undefined,
    };
  },

  toJSON(message: SetFabricConnectionRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.connectionId !== "") {
      obj.connectionId = message.connectionId;
    }
    if (message.connection !== undefined) {
      obj.connection = PortConnection.toJSON(message.connection);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SetFabricConnectionRequest>, I>>(base?: I): SetFabricConnectionRequest {
    return SetFabricConnectionRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetFabricConnectionRequest>, I>>(object: I): SetFabricConnectionRequest {
    const message = createBaseSetFabricConnectionRequest();
    message.fabricId = object.fabricId ?? "";
    message.connectionId = object.connectionId ?? "";
    message.connection = (object.connection !== undefined && object.connection !== null)
      ? PortConnection.fromPartial(object.connection)
      : undefined;
    return message;
  },
};

function createBaseFabricConnectionsResponse(): FabricConnectionsResponse {
  return { connections: [] };
}

export const FabricConnectionsResponse: MessageFns<FabricConnectionsResponse> = {
  encode(message: FabricConnectionsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.connections) {
      PortConnection.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FabricConnectionsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFabricConnectionsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.connections.push(PortConnection.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FabricConnectionsResponse {
    return {
      connections: globalThis.Array.isArray(object?.connections)
        ? object.connections.map((e: any) => PortConnection.fromJSON(e))
        : [],
    };
  },

  toJSON(message: FabricConnectionsResponse): unknown {
    const obj: any = {};
    if (message.connections?.length) {
      obj.connections = message.connections.map((e) => PortConnection.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FabricConnectionsResponse>, I>>(base?: I): FabricConnectionsResponse {
    return FabricConnectionsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FabricConnectionsResponse>, I>>(object: I): FabricConnectionsResponse {
    const message = createBaseFabricConnectionsResponse();
    message.connections = object.connections?.map((e) => PortConnection.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetFabricRevisionIdRequest(): GetFabricRevisionIdRequest {
  return {
    fabricId: "",
    committed: false,
    lookbackDuration: "",
    startTime: "",
    endTime: "",
    userId: "",
    max: 0,
    cursor: "",
    sortDesc: false,
    pagination: undefined,
  };
}

export const GetFabricRevisionIdRequest: MessageFns<GetFabricRevisionIdRequest> = {
  encode(message: GetFabricRevisionIdRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.committed !== false) {
      writer.uint32(16).bool(message.committed);
    }
    if (message.lookbackDuration !== "") {
      writer.uint32(26).string(message.lookbackDuration);
    }
    if (message.startTime !== "") {
      writer.uint32(34).string(message.startTime);
    }
    if (message.endTime !== "") {
      writer.uint32(42).string(message.endTime);
    }
    if (message.userId !== "") {
      writer.uint32(50).string(message.userId);
    }
    if (message.max !== 0) {
      writer.uint32(56).uint32(message.max);
    }
    if (message.cursor !== "") {
      writer.uint32(66).string(message.cursor);
    }
    if (message.sortDesc !== false) {
      writer.uint32(72).bool(message.sortDesc);
    }
    if (message.pagination !== undefined) {
      PaginationRequest.encode(message.pagination, writer.uint32(82).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetFabricRevisionIdRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetFabricRevisionIdRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.committed = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.lookbackDuration = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.startTime = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.endTime = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.userId = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.max = reader.uint32();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.cursor = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.sortDesc = reader.bool();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.pagination = PaginationRequest.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetFabricRevisionIdRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      committed: isSet(object.committed) ? globalThis.Boolean(object.committed) : false,
      lookbackDuration: isSet(object.lookbackDuration) ? globalThis.String(object.lookbackDuration) : "",
      startTime: isSet(object.startTime) ? globalThis.String(object.startTime) : "",
      endTime: isSet(object.endTime) ? globalThis.String(object.endTime) : "",
      userId: isSet(object.userId) ? globalThis.String(object.userId) : "",
      max: isSet(object.max) ? globalThis.Number(object.max) : 0,
      cursor: isSet(object.cursor) ? globalThis.String(object.cursor) : "",
      sortDesc: isSet(object.sortDesc) ? globalThis.Boolean(object.sortDesc) : false,
      pagination: isSet(object.pagination) ? PaginationRequest.fromJSON(object.pagination) : undefined,
    };
  },

  toJSON(message: GetFabricRevisionIdRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.committed !== false) {
      obj.committed = message.committed;
    }
    if (message.lookbackDuration !== "") {
      obj.lookbackDuration = message.lookbackDuration;
    }
    if (message.startTime !== "") {
      obj.startTime = message.startTime;
    }
    if (message.endTime !== "") {
      obj.endTime = message.endTime;
    }
    if (message.userId !== "") {
      obj.userId = message.userId;
    }
    if (message.max !== 0) {
      obj.max = Math.round(message.max);
    }
    if (message.cursor !== "") {
      obj.cursor = message.cursor;
    }
    if (message.sortDesc !== false) {
      obj.sortDesc = message.sortDesc;
    }
    if (message.pagination !== undefined) {
      obj.pagination = PaginationRequest.toJSON(message.pagination);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetFabricRevisionIdRequest>, I>>(base?: I): GetFabricRevisionIdRequest {
    return GetFabricRevisionIdRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetFabricRevisionIdRequest>, I>>(object: I): GetFabricRevisionIdRequest {
    const message = createBaseGetFabricRevisionIdRequest();
    message.fabricId = object.fabricId ?? "";
    message.committed = object.committed ?? false;
    message.lookbackDuration = object.lookbackDuration ?? "";
    message.startTime = object.startTime ?? "";
    message.endTime = object.endTime ?? "";
    message.userId = object.userId ?? "";
    message.max = object.max ?? 0;
    message.cursor = object.cursor ?? "";
    message.sortDesc = object.sortDesc ?? false;
    message.pagination = (object.pagination !== undefined && object.pagination !== null)
      ? PaginationRequest.fromPartial(object.pagination)
      : undefined;
    return message;
  },
};

function createBaseFabricRevisionIdResponse(): FabricRevisionIdResponse {
  return { fabricId: "", fabricName: "", revisionId: "0", pastRevisions: [], cursor: "", pagination: undefined };
}

export const FabricRevisionIdResponse: MessageFns<FabricRevisionIdResponse> = {
  encode(message: FabricRevisionIdResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.fabricName !== "") {
      writer.uint32(26).string(message.fabricName);
    }
    if (message.revisionId !== "0") {
      writer.uint32(16).int64(message.revisionId);
    }
    for (const v of message.pastRevisions) {
      CommittedRevisionMetadata.encode(v!, writer.uint32(34).fork()).join();
    }
    if (message.cursor !== "") {
      writer.uint32(42).string(message.cursor);
    }
    if (message.pagination !== undefined) {
      PaginationResponse.encode(message.pagination, writer.uint32(50).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FabricRevisionIdResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFabricRevisionIdResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.fabricName = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.revisionId = reader.int64().toString();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.pastRevisions.push(CommittedRevisionMetadata.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.cursor = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.pagination = PaginationResponse.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FabricRevisionIdResponse {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      fabricName: isSet(object.fabricName) ? globalThis.String(object.fabricName) : "",
      revisionId: isSet(object.revisionId) ? globalThis.String(object.revisionId) : "0",
      pastRevisions: globalThis.Array.isArray(object?.pastRevisions)
        ? object.pastRevisions.map((e: any) => CommittedRevisionMetadata.fromJSON(e))
        : [],
      cursor: isSet(object.cursor) ? globalThis.String(object.cursor) : "",
      pagination: isSet(object.pagination) ? PaginationResponse.fromJSON(object.pagination) : undefined,
    };
  },

  toJSON(message: FabricRevisionIdResponse): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.fabricName !== "") {
      obj.fabricName = message.fabricName;
    }
    if (message.revisionId !== "0") {
      obj.revisionId = message.revisionId;
    }
    if (message.pastRevisions?.length) {
      obj.pastRevisions = message.pastRevisions.map((e) => CommittedRevisionMetadata.toJSON(e));
    }
    if (message.cursor !== "") {
      obj.cursor = message.cursor;
    }
    if (message.pagination !== undefined) {
      obj.pagination = PaginationResponse.toJSON(message.pagination);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FabricRevisionIdResponse>, I>>(base?: I): FabricRevisionIdResponse {
    return FabricRevisionIdResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FabricRevisionIdResponse>, I>>(object: I): FabricRevisionIdResponse {
    const message = createBaseFabricRevisionIdResponse();
    message.fabricId = object.fabricId ?? "";
    message.fabricName = object.fabricName ?? "";
    message.revisionId = object.revisionId ?? "0";
    message.pastRevisions = object.pastRevisions?.map((e) => CommittedRevisionMetadata.fromPartial(e)) || [];
    message.cursor = object.cursor ?? "";
    message.pagination = (object.pagination !== undefined && object.pagination !== null)
      ? PaginationResponse.fromPartial(object.pagination)
      : undefined;
    return message;
  },
};

function createBaseCommittedRevisionMetadata(): CommittedRevisionMetadata {
  return { revisionId: "0", userId: "", createdAt: undefined, comments: "" };
}

export const CommittedRevisionMetadata: MessageFns<CommittedRevisionMetadata> = {
  encode(message: CommittedRevisionMetadata, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.revisionId !== "0") {
      writer.uint32(8).int64(message.revisionId);
    }
    if (message.userId !== "") {
      writer.uint32(18).string(message.userId);
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(26).fork()).join();
    }
    if (message.comments !== "") {
      writer.uint32(34).string(message.comments);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CommittedRevisionMetadata {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCommittedRevisionMetadata();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.revisionId = reader.int64().toString();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.userId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.comments = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CommittedRevisionMetadata {
    return {
      revisionId: isSet(object.revisionId) ? globalThis.String(object.revisionId) : "0",
      userId: isSet(object.userId) ? globalThis.String(object.userId) : "",
      createdAt: isSet(object.createdAt) ? fromJsonTimestamp(object.createdAt) : undefined,
      comments: isSet(object.comments) ? globalThis.String(object.comments) : "",
    };
  },

  toJSON(message: CommittedRevisionMetadata): unknown {
    const obj: any = {};
    if (message.revisionId !== "0") {
      obj.revisionId = message.revisionId;
    }
    if (message.userId !== "") {
      obj.userId = message.userId;
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt.toISOString();
    }
    if (message.comments !== "") {
      obj.comments = message.comments;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CommittedRevisionMetadata>, I>>(base?: I): CommittedRevisionMetadata {
    return CommittedRevisionMetadata.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CommittedRevisionMetadata>, I>>(object: I): CommittedRevisionMetadata {
    const message = createBaseCommittedRevisionMetadata();
    message.revisionId = object.revisionId ?? "0";
    message.userId = object.userId ?? "";
    message.createdAt = object.createdAt ?? undefined;
    message.comments = object.comments ?? "";
    return message;
  },
};

function createBasePortChannelsResponse(): PortChannelsResponse {
  return { portChannels: [] };
}

export const PortChannelsResponse: MessageFns<PortChannelsResponse> = {
  encode(message: PortChannelsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.portChannels) {
      PortChannel.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PortChannelsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePortChannelsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.portChannels.push(PortChannel.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PortChannelsResponse {
    return {
      portChannels: globalThis.Array.isArray(object?.portChannels)
        ? object.portChannels.map((e: any) => PortChannel.fromJSON(e))
        : [],
    };
  },

  toJSON(message: PortChannelsResponse): unknown {
    const obj: any = {};
    if (message.portChannels?.length) {
      obj.portChannels = message.portChannels.map((e) => PortChannel.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PortChannelsResponse>, I>>(base?: I): PortChannelsResponse {
    return PortChannelsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PortChannelsResponse>, I>>(object: I): PortChannelsResponse {
    const message = createBasePortChannelsResponse();
    message.portChannels = object.portChannels?.map((e) => PortChannel.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetAllPortChannelsRequest(): GetAllPortChannelsRequest {
  return { fabricId: "", candidate: "", includeMetadata: false };
}

export const GetAllPortChannelsRequest: MessageFns<GetAllPortChannelsRequest> = {
  encode(message: GetAllPortChannelsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.candidate !== "") {
      writer.uint32(18).string(message.candidate);
    }
    if (message.includeMetadata !== false) {
      writer.uint32(24).bool(message.includeMetadata);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetAllPortChannelsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetAllPortChannelsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.candidate = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.includeMetadata = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetAllPortChannelsRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      candidate: isSet(object.candidate) ? globalThis.String(object.candidate) : "",
      includeMetadata: isSet(object.includeMetadata) ? globalThis.Boolean(object.includeMetadata) : false,
    };
  },

  toJSON(message: GetAllPortChannelsRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.candidate !== "") {
      obj.candidate = message.candidate;
    }
    if (message.includeMetadata !== false) {
      obj.includeMetadata = message.includeMetadata;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetAllPortChannelsRequest>, I>>(base?: I): GetAllPortChannelsRequest {
    return GetAllPortChannelsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetAllPortChannelsRequest>, I>>(object: I): GetAllPortChannelsRequest {
    const message = createBaseGetAllPortChannelsRequest();
    message.fabricId = object.fabricId ?? "";
    message.candidate = object.candidate ?? "";
    message.includeMetadata = object.includeMetadata ?? false;
    return message;
  },
};

function createBaseGetPortChannelRequest(): GetPortChannelRequest {
  return { fabricId: "", candidate: "", id: "", includeMetadata: false };
}

export const GetPortChannelRequest: MessageFns<GetPortChannelRequest> = {
  encode(message: GetPortChannelRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.candidate !== "") {
      writer.uint32(18).string(message.candidate);
    }
    if (message.id !== "") {
      writer.uint32(26).string(message.id);
    }
    if (message.includeMetadata !== false) {
      writer.uint32(32).bool(message.includeMetadata);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetPortChannelRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetPortChannelRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.candidate = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.includeMetadata = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetPortChannelRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      candidate: isSet(object.candidate) ? globalThis.String(object.candidate) : "",
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      includeMetadata: isSet(object.includeMetadata) ? globalThis.Boolean(object.includeMetadata) : false,
    };
  },

  toJSON(message: GetPortChannelRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.candidate !== "") {
      obj.candidate = message.candidate;
    }
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.includeMetadata !== false) {
      obj.includeMetadata = message.includeMetadata;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetPortChannelRequest>, I>>(base?: I): GetPortChannelRequest {
    return GetPortChannelRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetPortChannelRequest>, I>>(object: I): GetPortChannelRequest {
    const message = createBaseGetPortChannelRequest();
    message.fabricId = object.fabricId ?? "";
    message.candidate = object.candidate ?? "";
    message.id = object.id ?? "";
    message.includeMetadata = object.includeMetadata ?? false;
    return message;
  },
};

function createBaseAddPortChannelsRequest(): AddPortChannelsRequest {
  return { fabricId: "", portChannels: [] };
}

export const AddPortChannelsRequest: MessageFns<AddPortChannelsRequest> = {
  encode(message: AddPortChannelsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    for (const v of message.portChannels) {
      PortChannel.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AddPortChannelsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAddPortChannelsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.portChannels.push(PortChannel.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AddPortChannelsRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      portChannels: globalThis.Array.isArray(object?.portChannels)
        ? object.portChannels.map((e: any) => PortChannel.fromJSON(e))
        : [],
    };
  },

  toJSON(message: AddPortChannelsRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.portChannels?.length) {
      obj.portChannels = message.portChannels.map((e) => PortChannel.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AddPortChannelsRequest>, I>>(base?: I): AddPortChannelsRequest {
    return AddPortChannelsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AddPortChannelsRequest>, I>>(object: I): AddPortChannelsRequest {
    const message = createBaseAddPortChannelsRequest();
    message.fabricId = object.fabricId ?? "";
    message.portChannels = object.portChannels?.map((e) => PortChannel.fromPartial(e)) || [];
    return message;
  },
};

function createBaseUpdatePortChannelRequest(): UpdatePortChannelRequest {
  return { fabricId: "", id: "", portChannel: undefined };
}

export const UpdatePortChannelRequest: MessageFns<UpdatePortChannelRequest> = {
  encode(message: UpdatePortChannelRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.id !== "") {
      writer.uint32(18).string(message.id);
    }
    if (message.portChannel !== undefined) {
      PortChannel.encode(message.portChannel, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdatePortChannelRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdatePortChannelRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.portChannel = PortChannel.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdatePortChannelRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      portChannel: isSet(object.portChannel) ? PortChannel.fromJSON(object.portChannel) : undefined,
    };
  },

  toJSON(message: UpdatePortChannelRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.portChannel !== undefined) {
      obj.portChannel = PortChannel.toJSON(message.portChannel);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdatePortChannelRequest>, I>>(base?: I): UpdatePortChannelRequest {
    return UpdatePortChannelRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdatePortChannelRequest>, I>>(object: I): UpdatePortChannelRequest {
    const message = createBaseUpdatePortChannelRequest();
    message.fabricId = object.fabricId ?? "";
    message.id = object.id ?? "";
    message.portChannel = (object.portChannel !== undefined && object.portChannel !== null)
      ? PortChannel.fromPartial(object.portChannel)
      : undefined;
    return message;
  },
};

function createBaseDeletePortChannelRequest(): DeletePortChannelRequest {
  return { fabricId: "", id: "" };
}

export const DeletePortChannelRequest: MessageFns<DeletePortChannelRequest> = {
  encode(message: DeletePortChannelRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.id !== "") {
      writer.uint32(18).string(message.id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeletePortChannelRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeletePortChannelRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeletePortChannelRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      id: isSet(object.id) ? globalThis.String(object.id) : "",
    };
  },

  toJSON(message: DeletePortChannelRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.id !== "") {
      obj.id = message.id;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeletePortChannelRequest>, I>>(base?: I): DeletePortChannelRequest {
    return DeletePortChannelRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeletePortChannelRequest>, I>>(object: I): DeletePortChannelRequest {
    const message = createBaseDeletePortChannelRequest();
    message.fabricId = object.fabricId ?? "";
    message.id = object.id ?? "";
    return message;
  },
};

function createBaseGetFabricStpRequest(): GetFabricStpRequest {
  return { fabricId: "", candidate: "", includeMetadata: false };
}

export const GetFabricStpRequest: MessageFns<GetFabricStpRequest> = {
  encode(message: GetFabricStpRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.candidate !== "") {
      writer.uint32(18).string(message.candidate);
    }
    if (message.includeMetadata !== false) {
      writer.uint32(24).bool(message.includeMetadata);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetFabricStpRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetFabricStpRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.candidate = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.includeMetadata = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetFabricStpRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      candidate: isSet(object.candidate) ? globalThis.String(object.candidate) : "",
      includeMetadata: isSet(object.includeMetadata) ? globalThis.Boolean(object.includeMetadata) : false,
    };
  },

  toJSON(message: GetFabricStpRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.candidate !== "") {
      obj.candidate = message.candidate;
    }
    if (message.includeMetadata !== false) {
      obj.includeMetadata = message.includeMetadata;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetFabricStpRequest>, I>>(base?: I): GetFabricStpRequest {
    return GetFabricStpRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetFabricStpRequest>, I>>(object: I): GetFabricStpRequest {
    const message = createBaseGetFabricStpRequest();
    message.fabricId = object.fabricId ?? "";
    message.candidate = object.candidate ?? "";
    message.includeMetadata = object.includeMetadata ?? false;
    return message;
  },
};

function createBaseUpdateFabricStpRequest(): UpdateFabricStpRequest {
  return { fabricId: "", stp: undefined };
}

export const UpdateFabricStpRequest: MessageFns<UpdateFabricStpRequest> = {
  encode(message: UpdateFabricStpRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.stp !== undefined) {
      PerVlanStp.encode(message.stp, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UpdateFabricStpRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateFabricStpRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.stp = PerVlanStp.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateFabricStpRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      stp: isSet(object.stp) ? PerVlanStp.fromJSON(object.stp) : undefined,
    };
  },

  toJSON(message: UpdateFabricStpRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.stp !== undefined) {
      obj.stp = PerVlanStp.toJSON(message.stp);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateFabricStpRequest>, I>>(base?: I): UpdateFabricStpRequest {
    return UpdateFabricStpRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateFabricStpRequest>, I>>(object: I): UpdateFabricStpRequest {
    const message = createBaseUpdateFabricStpRequest();
    message.fabricId = object.fabricId ?? "";
    message.stp = (object.stp !== undefined && object.stp !== null) ? PerVlanStp.fromPartial(object.stp) : undefined;
    return message;
  },
};

function createBaseResetFabricStpRequest(): ResetFabricStpRequest {
  return { fabricId: "" };
}

export const ResetFabricStpRequest: MessageFns<ResetFabricStpRequest> = {
  encode(message: ResetFabricStpRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ResetFabricStpRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseResetFabricStpRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ResetFabricStpRequest {
    return { fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "" };
  },

  toJSON(message: ResetFabricStpRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ResetFabricStpRequest>, I>>(base?: I): ResetFabricStpRequest {
    return ResetFabricStpRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ResetFabricStpRequest>, I>>(object: I): ResetFabricStpRequest {
    const message = createBaseResetFabricStpRequest();
    message.fabricId = object.fabricId ?? "";
    return message;
  },
};

function createBaseStreamConfigRequest(): StreamConfigRequest {
  return { fabricId: "" };
}

export const StreamConfigRequest: MessageFns<StreamConfigRequest> = {
  encode(message: StreamConfigRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StreamConfigRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStreamConfigRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StreamConfigRequest {
    return { fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "" };
  },

  toJSON(message: StreamConfigRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StreamConfigRequest>, I>>(base?: I): StreamConfigRequest {
    return StreamConfigRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StreamConfigRequest>, I>>(object: I): StreamConfigRequest {
    const message = createBaseStreamConfigRequest();
    message.fabricId = object.fabricId ?? "";
    return message;
  },
};

function createBaseRestoreFabricRevisionRequest(): RestoreFabricRevisionRequest {
  return { fabricId: "", revisionId: "0", dryRun: false, password: "", autoCommit: false, revisionConfig: undefined };
}

export const RestoreFabricRevisionRequest: MessageFns<RestoreFabricRevisionRequest> = {
  encode(message: RestoreFabricRevisionRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.revisionId !== "0") {
      writer.uint32(16).int64(message.revisionId);
    }
    if (message.dryRun !== false) {
      writer.uint32(24).bool(message.dryRun);
    }
    if (message.password !== "") {
      writer.uint32(34).string(message.password);
    }
    if (message.autoCommit !== false) {
      writer.uint32(40).bool(message.autoCommit);
    }
    if (message.revisionConfig !== undefined) {
      ExportedFabricRevision.encode(message.revisionConfig, writer.uint32(82).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RestoreFabricRevisionRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRestoreFabricRevisionRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.revisionId = reader.int64().toString();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.dryRun = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.password = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.autoCommit = reader.bool();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.revisionConfig = ExportedFabricRevision.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RestoreFabricRevisionRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      revisionId: isSet(object.revisionId) ? globalThis.String(object.revisionId) : "0",
      dryRun: isSet(object.dryRun) ? globalThis.Boolean(object.dryRun) : false,
      password: isSet(object.password) ? globalThis.String(object.password) : "",
      autoCommit: isSet(object.autoCommit) ? globalThis.Boolean(object.autoCommit) : false,
      revisionConfig: isSet(object.revisionConfig) ? ExportedFabricRevision.fromJSON(object.revisionConfig) : undefined,
    };
  },

  toJSON(message: RestoreFabricRevisionRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.revisionId !== "0") {
      obj.revisionId = message.revisionId;
    }
    if (message.dryRun !== false) {
      obj.dryRun = message.dryRun;
    }
    if (message.password !== "") {
      obj.password = message.password;
    }
    if (message.autoCommit !== false) {
      obj.autoCommit = message.autoCommit;
    }
    if (message.revisionConfig !== undefined) {
      obj.revisionConfig = ExportedFabricRevision.toJSON(message.revisionConfig);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RestoreFabricRevisionRequest>, I>>(base?: I): RestoreFabricRevisionRequest {
    return RestoreFabricRevisionRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RestoreFabricRevisionRequest>, I>>(object: I): RestoreFabricRevisionRequest {
    const message = createBaseRestoreFabricRevisionRequest();
    message.fabricId = object.fabricId ?? "";
    message.revisionId = object.revisionId ?? "0";
    message.dryRun = object.dryRun ?? false;
    message.password = object.password ?? "";
    message.autoCommit = object.autoCommit ?? false;
    message.revisionConfig = (object.revisionConfig !== undefined && object.revisionConfig !== null)
      ? ExportedFabricRevision.fromPartial(object.revisionConfig)
      : undefined;
    return message;
  },
};

function createBaseFabricRevisionConfig(): FabricRevisionConfig {
  return { metadata: undefined, config: undefined };
}

export const FabricRevisionConfig: MessageFns<FabricRevisionConfig> = {
  encode(message: FabricRevisionConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.metadata !== undefined) {
      CommittedRevisionMetadata.encode(message.metadata, writer.uint32(10).fork()).join();
    }
    if (message.config !== undefined) {
      FabricConfig.encode(message.config, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): FabricRevisionConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFabricRevisionConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.metadata = CommittedRevisionMetadata.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.config = FabricConfig.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FabricRevisionConfig {
    return {
      metadata: isSet(object.metadata) ? CommittedRevisionMetadata.fromJSON(object.metadata) : undefined,
      config: isSet(object.config) ? FabricConfig.fromJSON(object.config) : undefined,
    };
  },

  toJSON(message: FabricRevisionConfig): unknown {
    const obj: any = {};
    if (message.metadata !== undefined) {
      obj.metadata = CommittedRevisionMetadata.toJSON(message.metadata);
    }
    if (message.config !== undefined) {
      obj.config = FabricConfig.toJSON(message.config);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FabricRevisionConfig>, I>>(base?: I): FabricRevisionConfig {
    return FabricRevisionConfig.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FabricRevisionConfig>, I>>(object: I): FabricRevisionConfig {
    const message = createBaseFabricRevisionConfig();
    message.metadata = (object.metadata !== undefined && object.metadata !== null)
      ? CommittedRevisionMetadata.fromPartial(object.metadata)
      : undefined;
    message.config = (object.config !== undefined && object.config !== null)
      ? FabricConfig.fromPartial(object.config)
      : undefined;
    return message;
  },
};

function createBaseRestoreFabricRevisionResponse(): RestoreFabricRevisionResponse {
  return { restoredConfig: undefined, warnings: [] };
}

export const RestoreFabricRevisionResponse: MessageFns<RestoreFabricRevisionResponse> = {
  encode(message: RestoreFabricRevisionResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.restoredConfig !== undefined) {
      FabricConfig.encode(message.restoredConfig, writer.uint32(10).fork()).join();
    }
    for (const v of message.warnings) {
      RestWarning.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RestoreFabricRevisionResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRestoreFabricRevisionResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.restoredConfig = FabricConfig.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.warnings.push(RestWarning.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RestoreFabricRevisionResponse {
    return {
      restoredConfig: isSet(object.restoredConfig) ? FabricConfig.fromJSON(object.restoredConfig) : undefined,
      warnings: globalThis.Array.isArray(object?.warnings)
        ? object.warnings.map((e: any) => RestWarning.fromJSON(e))
        : [],
    };
  },

  toJSON(message: RestoreFabricRevisionResponse): unknown {
    const obj: any = {};
    if (message.restoredConfig !== undefined) {
      obj.restoredConfig = FabricConfig.toJSON(message.restoredConfig);
    }
    if (message.warnings?.length) {
      obj.warnings = message.warnings.map((e) => RestWarning.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RestoreFabricRevisionResponse>, I>>(base?: I): RestoreFabricRevisionResponse {
    return RestoreFabricRevisionResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RestoreFabricRevisionResponse>, I>>(
    object: I,
  ): RestoreFabricRevisionResponse {
    const message = createBaseRestoreFabricRevisionResponse();
    message.restoredConfig = (object.restoredConfig !== undefined && object.restoredConfig !== null)
      ? FabricConfig.fromPartial(object.restoredConfig)
      : undefined;
    message.warnings = object.warnings?.map((e) => RestWarning.fromPartial(e)) || [];
    return message;
  },
};

function createBaseCreateFabricRevisionExportRequest(): CreateFabricRevisionExportRequest {
  return { fabricId: "", revisionId: "0", password: "" };
}

export const CreateFabricRevisionExportRequest: MessageFns<CreateFabricRevisionExportRequest> = {
  encode(message: CreateFabricRevisionExportRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.revisionId !== "0") {
      writer.uint32(16).int64(message.revisionId);
    }
    if (message.password !== "") {
      writer.uint32(26).string(message.password);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateFabricRevisionExportRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateFabricRevisionExportRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.revisionId = reader.int64().toString();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.password = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateFabricRevisionExportRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      revisionId: isSet(object.revisionId) ? globalThis.String(object.revisionId) : "0",
      password: isSet(object.password) ? globalThis.String(object.password) : "",
    };
  },

  toJSON(message: CreateFabricRevisionExportRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.revisionId !== "0") {
      obj.revisionId = message.revisionId;
    }
    if (message.password !== "") {
      obj.password = message.password;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateFabricRevisionExportRequest>, I>>(
    base?: I,
  ): CreateFabricRevisionExportRequest {
    return CreateFabricRevisionExportRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateFabricRevisionExportRequest>, I>>(
    object: I,
  ): CreateFabricRevisionExportRequest {
    const message = createBaseCreateFabricRevisionExportRequest();
    message.fabricId = object.fabricId ?? "";
    message.revisionId = object.revisionId ?? "0";
    message.password = object.password ?? "";
    return message;
  },
};

function createBaseExportedFabricRevision(): ExportedFabricRevision {
  return { fabricId: "", fabricName: "", revisionMetadata: undefined, exportMetadata: undefined, config: undefined };
}

export const ExportedFabricRevision: MessageFns<ExportedFabricRevision> = {
  encode(message: ExportedFabricRevision, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.fabricName !== "") {
      writer.uint32(18).string(message.fabricName);
    }
    if (message.revisionMetadata !== undefined) {
      CommittedRevisionMetadata.encode(message.revisionMetadata, writer.uint32(26).fork()).join();
    }
    if (message.exportMetadata !== undefined) {
      ExportedRevisionMetadata.encode(message.exportMetadata, writer.uint32(34).fork()).join();
    }
    if (message.config !== undefined) {
      ExportedFabricConfiguration.encode(message.config, writer.uint32(82).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ExportedFabricRevision {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseExportedFabricRevision();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.fabricName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.revisionMetadata = CommittedRevisionMetadata.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.exportMetadata = ExportedRevisionMetadata.decode(reader, reader.uint32());
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.config = ExportedFabricConfiguration.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ExportedFabricRevision {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      fabricName: isSet(object.fabricName) ? globalThis.String(object.fabricName) : "",
      revisionMetadata: isSet(object.revisionMetadata)
        ? CommittedRevisionMetadata.fromJSON(object.revisionMetadata)
        : undefined,
      exportMetadata: isSet(object.exportMetadata)
        ? ExportedRevisionMetadata.fromJSON(object.exportMetadata)
        : undefined,
      config: isSet(object.config) ? ExportedFabricConfiguration.fromJSON(object.config) : undefined,
    };
  },

  toJSON(message: ExportedFabricRevision): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.fabricName !== "") {
      obj.fabricName = message.fabricName;
    }
    if (message.revisionMetadata !== undefined) {
      obj.revisionMetadata = CommittedRevisionMetadata.toJSON(message.revisionMetadata);
    }
    if (message.exportMetadata !== undefined) {
      obj.exportMetadata = ExportedRevisionMetadata.toJSON(message.exportMetadata);
    }
    if (message.config !== undefined) {
      obj.config = ExportedFabricConfiguration.toJSON(message.config);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ExportedFabricRevision>, I>>(base?: I): ExportedFabricRevision {
    return ExportedFabricRevision.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ExportedFabricRevision>, I>>(object: I): ExportedFabricRevision {
    const message = createBaseExportedFabricRevision();
    message.fabricId = object.fabricId ?? "";
    message.fabricName = object.fabricName ?? "";
    message.revisionMetadata = (object.revisionMetadata !== undefined && object.revisionMetadata !== null)
      ? CommittedRevisionMetadata.fromPartial(object.revisionMetadata)
      : undefined;
    message.exportMetadata = (object.exportMetadata !== undefined && object.exportMetadata !== null)
      ? ExportedRevisionMetadata.fromPartial(object.exportMetadata)
      : undefined;
    message.config = (object.config !== undefined && object.config !== null)
      ? ExportedFabricConfiguration.fromPartial(object.config)
      : undefined;
    return message;
  },
};

function createBaseExportedRevisionMetadata(): ExportedRevisionMetadata {
  return { exportedAt: undefined, exportedBy: "", secret: "" };
}

export const ExportedRevisionMetadata: MessageFns<ExportedRevisionMetadata> = {
  encode(message: ExportedRevisionMetadata, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.exportedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.exportedAt), writer.uint32(10).fork()).join();
    }
    if (message.exportedBy !== "") {
      writer.uint32(18).string(message.exportedBy);
    }
    if (message.secret !== "") {
      writer.uint32(26).string(message.secret);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ExportedRevisionMetadata {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseExportedRevisionMetadata();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.exportedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.exportedBy = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.secret = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ExportedRevisionMetadata {
    return {
      exportedAt: isSet(object.exportedAt) ? fromJsonTimestamp(object.exportedAt) : undefined,
      exportedBy: isSet(object.exportedBy) ? globalThis.String(object.exportedBy) : "",
      secret: isSet(object.secret) ? globalThis.String(object.secret) : "",
    };
  },

  toJSON(message: ExportedRevisionMetadata): unknown {
    const obj: any = {};
    if (message.exportedAt !== undefined) {
      obj.exportedAt = message.exportedAt.toISOString();
    }
    if (message.exportedBy !== "") {
      obj.exportedBy = message.exportedBy;
    }
    if (message.secret !== "") {
      obj.secret = message.secret;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ExportedRevisionMetadata>, I>>(base?: I): ExportedRevisionMetadata {
    return ExportedRevisionMetadata.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ExportedRevisionMetadata>, I>>(object: I): ExportedRevisionMetadata {
    const message = createBaseExportedRevisionMetadata();
    message.exportedAt = object.exportedAt ?? undefined;
    message.exportedBy = object.exportedBy ?? "";
    message.secret = object.secret ?? "";
    return message;
  },
};

function createBaseCloneFabricRequest(): CloneFabricRequest {
  return { fabricId: "", cloneName: "", background: false };
}

export const CloneFabricRequest: MessageFns<CloneFabricRequest> = {
  encode(message: CloneFabricRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.cloneName !== "") {
      writer.uint32(18).string(message.cloneName);
    }
    if (message.background !== false) {
      writer.uint32(24).bool(message.background);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CloneFabricRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCloneFabricRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.cloneName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.background = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CloneFabricRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      cloneName: isSet(object.cloneName) ? globalThis.String(object.cloneName) : "",
      background: isSet(object.background) ? globalThis.Boolean(object.background) : false,
    };
  },

  toJSON(message: CloneFabricRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.cloneName !== "") {
      obj.cloneName = message.cloneName;
    }
    if (message.background !== false) {
      obj.background = message.background;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CloneFabricRequest>, I>>(base?: I): CloneFabricRequest {
    return CloneFabricRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CloneFabricRequest>, I>>(object: I): CloneFabricRequest {
    const message = createBaseCloneFabricRequest();
    message.fabricId = object.fabricId ?? "";
    message.cloneName = object.cloneName ?? "";
    message.background = object.background ?? false;
    return message;
  },
};

function createBaseCloneFabricResponse(): CloneFabricResponse {
  return { config: undefined, taskId: "", taskStatus: 0 };
}

export const CloneFabricResponse: MessageFns<CloneFabricResponse> = {
  encode(message: CloneFabricResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.config !== undefined) {
      FabricConfig.encode(message.config, writer.uint32(10).fork()).join();
    }
    if (message.taskId !== "") {
      writer.uint32(18).string(message.taskId);
    }
    if (message.taskStatus !== 0) {
      writer.uint32(24).int32(message.taskStatus);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CloneFabricResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCloneFabricResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.config = FabricConfig.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.taskId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.taskStatus = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CloneFabricResponse {
    return {
      config: isSet(object.config) ? FabricConfig.fromJSON(object.config) : undefined,
      taskId: isSet(object.taskId) ? globalThis.String(object.taskId) : "",
      taskStatus: isSet(object.taskStatus) ? taskStatusTypeFromJSON(object.taskStatus) : 0,
    };
  },

  toJSON(message: CloneFabricResponse): unknown {
    const obj: any = {};
    if (message.config !== undefined) {
      obj.config = FabricConfig.toJSON(message.config);
    }
    if (message.taskId !== "") {
      obj.taskId = message.taskId;
    }
    if (message.taskStatus !== 0) {
      obj.taskStatus = taskStatusTypeToJSON(message.taskStatus);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CloneFabricResponse>, I>>(base?: I): CloneFabricResponse {
    return CloneFabricResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CloneFabricResponse>, I>>(object: I): CloneFabricResponse {
    const message = createBaseCloneFabricResponse();
    message.config = (object.config !== undefined && object.config !== null)
      ? FabricConfig.fromPartial(object.config)
      : undefined;
    message.taskId = object.taskId ?? "";
    message.taskStatus = object.taskStatus ?? 0;
    return message;
  },
};

function createBaseGetDeletedFabricsRequest(): GetDeletedFabricsRequest {
  return {
    lookbackDuration: "",
    startTime: "",
    endTime: "",
    userId: "",
    max: 0,
    cursor: "",
    sortDesc: false,
    pagination: undefined,
  };
}

export const GetDeletedFabricsRequest: MessageFns<GetDeletedFabricsRequest> = {
  encode(message: GetDeletedFabricsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.lookbackDuration !== "") {
      writer.uint32(10).string(message.lookbackDuration);
    }
    if (message.startTime !== "") {
      writer.uint32(18).string(message.startTime);
    }
    if (message.endTime !== "") {
      writer.uint32(26).string(message.endTime);
    }
    if (message.userId !== "") {
      writer.uint32(34).string(message.userId);
    }
    if (message.max !== 0) {
      writer.uint32(56).uint32(message.max);
    }
    if (message.cursor !== "") {
      writer.uint32(66).string(message.cursor);
    }
    if (message.sortDesc !== false) {
      writer.uint32(72).bool(message.sortDesc);
    }
    if (message.pagination !== undefined) {
      PaginationRequest.encode(message.pagination, writer.uint32(82).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetDeletedFabricsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetDeletedFabricsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.lookbackDuration = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.startTime = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.endTime = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.userId = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.max = reader.uint32();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.cursor = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.sortDesc = reader.bool();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.pagination = PaginationRequest.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetDeletedFabricsRequest {
    return {
      lookbackDuration: isSet(object.lookbackDuration) ? globalThis.String(object.lookbackDuration) : "",
      startTime: isSet(object.startTime) ? globalThis.String(object.startTime) : "",
      endTime: isSet(object.endTime) ? globalThis.String(object.endTime) : "",
      userId: isSet(object.userId) ? globalThis.String(object.userId) : "",
      max: isSet(object.max) ? globalThis.Number(object.max) : 0,
      cursor: isSet(object.cursor) ? globalThis.String(object.cursor) : "",
      sortDesc: isSet(object.sortDesc) ? globalThis.Boolean(object.sortDesc) : false,
      pagination: isSet(object.pagination) ? PaginationRequest.fromJSON(object.pagination) : undefined,
    };
  },

  toJSON(message: GetDeletedFabricsRequest): unknown {
    const obj: any = {};
    if (message.lookbackDuration !== "") {
      obj.lookbackDuration = message.lookbackDuration;
    }
    if (message.startTime !== "") {
      obj.startTime = message.startTime;
    }
    if (message.endTime !== "") {
      obj.endTime = message.endTime;
    }
    if (message.userId !== "") {
      obj.userId = message.userId;
    }
    if (message.max !== 0) {
      obj.max = Math.round(message.max);
    }
    if (message.cursor !== "") {
      obj.cursor = message.cursor;
    }
    if (message.sortDesc !== false) {
      obj.sortDesc = message.sortDesc;
    }
    if (message.pagination !== undefined) {
      obj.pagination = PaginationRequest.toJSON(message.pagination);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetDeletedFabricsRequest>, I>>(base?: I): GetDeletedFabricsRequest {
    return GetDeletedFabricsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetDeletedFabricsRequest>, I>>(object: I): GetDeletedFabricsRequest {
    const message = createBaseGetDeletedFabricsRequest();
    message.lookbackDuration = object.lookbackDuration ?? "";
    message.startTime = object.startTime ?? "";
    message.endTime = object.endTime ?? "";
    message.userId = object.userId ?? "";
    message.max = object.max ?? 0;
    message.cursor = object.cursor ?? "";
    message.sortDesc = object.sortDesc ?? false;
    message.pagination = (object.pagination !== undefined && object.pagination !== null)
      ? PaginationRequest.fromPartial(object.pagination)
      : undefined;
    return message;
  },
};

function createBaseGetDeletedFabricsResponse(): GetDeletedFabricsResponse {
  return { fabrics: [], cursor: "", pagination: undefined };
}

export const GetDeletedFabricsResponse: MessageFns<GetDeletedFabricsResponse> = {
  encode(message: GetDeletedFabricsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.fabrics) {
      DeletedFabricMetadata.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.cursor !== "") {
      writer.uint32(18).string(message.cursor);
    }
    if (message.pagination !== undefined) {
      PaginationResponse.encode(message.pagination, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetDeletedFabricsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetDeletedFabricsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabrics.push(DeletedFabricMetadata.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.cursor = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.pagination = PaginationResponse.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetDeletedFabricsResponse {
    return {
      fabrics: globalThis.Array.isArray(object?.fabrics)
        ? object.fabrics.map((e: any) => DeletedFabricMetadata.fromJSON(e))
        : [],
      cursor: isSet(object.cursor) ? globalThis.String(object.cursor) : "",
      pagination: isSet(object.pagination) ? PaginationResponse.fromJSON(object.pagination) : undefined,
    };
  },

  toJSON(message: GetDeletedFabricsResponse): unknown {
    const obj: any = {};
    if (message.fabrics?.length) {
      obj.fabrics = message.fabrics.map((e) => DeletedFabricMetadata.toJSON(e));
    }
    if (message.cursor !== "") {
      obj.cursor = message.cursor;
    }
    if (message.pagination !== undefined) {
      obj.pagination = PaginationResponse.toJSON(message.pagination);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetDeletedFabricsResponse>, I>>(base?: I): GetDeletedFabricsResponse {
    return GetDeletedFabricsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetDeletedFabricsResponse>, I>>(object: I): GetDeletedFabricsResponse {
    const message = createBaseGetDeletedFabricsResponse();
    message.fabrics = object.fabrics?.map((e) => DeletedFabricMetadata.fromPartial(e)) || [];
    message.cursor = object.cursor ?? "";
    message.pagination = (object.pagination !== undefined && object.pagination !== null)
      ? PaginationResponse.fromPartial(object.pagination)
      : undefined;
    return message;
  },
};

function createBaseCreateDeletedFabricExportRequest(): CreateDeletedFabricExportRequest {
  return { fabricId: "", password: "" };
}

export const CreateDeletedFabricExportRequest: MessageFns<CreateDeletedFabricExportRequest> = {
  encode(message: CreateDeletedFabricExportRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.password !== "") {
      writer.uint32(18).string(message.password);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateDeletedFabricExportRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateDeletedFabricExportRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.password = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateDeletedFabricExportRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      password: isSet(object.password) ? globalThis.String(object.password) : "",
    };
  },

  toJSON(message: CreateDeletedFabricExportRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.password !== "") {
      obj.password = message.password;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreateDeletedFabricExportRequest>, I>>(
    base?: I,
  ): CreateDeletedFabricExportRequest {
    return CreateDeletedFabricExportRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreateDeletedFabricExportRequest>, I>>(
    object: I,
  ): CreateDeletedFabricExportRequest {
    const message = createBaseCreateDeletedFabricExportRequest();
    message.fabricId = object.fabricId ?? "";
    message.password = object.password ?? "";
    return message;
  },
};

function createBaseRestoreDeletedFabricRequest(): RestoreDeletedFabricRequest {
  return { fabricId: "", dryRun: false, autoCommit: false, password: "", revisionConfig: undefined };
}

export const RestoreDeletedFabricRequest: MessageFns<RestoreDeletedFabricRequest> = {
  encode(message: RestoreDeletedFabricRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.dryRun !== false) {
      writer.uint32(16).bool(message.dryRun);
    }
    if (message.autoCommit !== false) {
      writer.uint32(24).bool(message.autoCommit);
    }
    if (message.password !== "") {
      writer.uint32(34).string(message.password);
    }
    if (message.revisionConfig !== undefined) {
      ExportedFabricRevision.encode(message.revisionConfig, writer.uint32(82).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RestoreDeletedFabricRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRestoreDeletedFabricRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.dryRun = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.autoCommit = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.password = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.revisionConfig = ExportedFabricRevision.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RestoreDeletedFabricRequest {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      dryRun: isSet(object.dryRun) ? globalThis.Boolean(object.dryRun) : false,
      autoCommit: isSet(object.autoCommit) ? globalThis.Boolean(object.autoCommit) : false,
      password: isSet(object.password) ? globalThis.String(object.password) : "",
      revisionConfig: isSet(object.revisionConfig) ? ExportedFabricRevision.fromJSON(object.revisionConfig) : undefined,
    };
  },

  toJSON(message: RestoreDeletedFabricRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.dryRun !== false) {
      obj.dryRun = message.dryRun;
    }
    if (message.autoCommit !== false) {
      obj.autoCommit = message.autoCommit;
    }
    if (message.password !== "") {
      obj.password = message.password;
    }
    if (message.revisionConfig !== undefined) {
      obj.revisionConfig = ExportedFabricRevision.toJSON(message.revisionConfig);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RestoreDeletedFabricRequest>, I>>(base?: I): RestoreDeletedFabricRequest {
    return RestoreDeletedFabricRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RestoreDeletedFabricRequest>, I>>(object: I): RestoreDeletedFabricRequest {
    const message = createBaseRestoreDeletedFabricRequest();
    message.fabricId = object.fabricId ?? "";
    message.dryRun = object.dryRun ?? false;
    message.autoCommit = object.autoCommit ?? false;
    message.password = object.password ?? "";
    message.revisionConfig = (object.revisionConfig !== undefined && object.revisionConfig !== null)
      ? ExportedFabricRevision.fromPartial(object.revisionConfig)
      : undefined;
    return message;
  },
};

function createBaseDeletedFabricMetadata(): DeletedFabricMetadata {
  return { fabricName: "", fabricId: "", deletedBy: "", deletedAt: undefined };
}

export const DeletedFabricMetadata: MessageFns<DeletedFabricMetadata> = {
  encode(message: DeletedFabricMetadata, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricName !== "") {
      writer.uint32(10).string(message.fabricName);
    }
    if (message.fabricId !== "") {
      writer.uint32(18).string(message.fabricId);
    }
    if (message.deletedBy !== "") {
      writer.uint32(26).string(message.deletedBy);
    }
    if (message.deletedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.deletedAt), writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DeletedFabricMetadata {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeletedFabricMetadata();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricName = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.deletedBy = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.deletedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeletedFabricMetadata {
    return {
      fabricName: isSet(object.fabricName) ? globalThis.String(object.fabricName) : "",
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      deletedBy: isSet(object.deletedBy) ? globalThis.String(object.deletedBy) : "",
      deletedAt: isSet(object.deletedAt) ? fromJsonTimestamp(object.deletedAt) : undefined,
    };
  },

  toJSON(message: DeletedFabricMetadata): unknown {
    const obj: any = {};
    if (message.fabricName !== "") {
      obj.fabricName = message.fabricName;
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.deletedBy !== "") {
      obj.deletedBy = message.deletedBy;
    }
    if (message.deletedAt !== undefined) {
      obj.deletedAt = message.deletedAt.toISOString();
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeletedFabricMetadata>, I>>(base?: I): DeletedFabricMetadata {
    return DeletedFabricMetadata.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeletedFabricMetadata>, I>>(object: I): DeletedFabricMetadata {
    const message = createBaseDeletedFabricMetadata();
    message.fabricName = object.fabricName ?? "";
    message.fabricId = object.fabricId ?? "";
    message.deletedBy = object.deletedBy ?? "";
    message.deletedAt = object.deletedAt ?? undefined;
    return message;
  },
};

function createBaseGetFabricShareableLinkRequest(): GetFabricShareableLinkRequest {
  return { fabricId: "" };
}

export const GetFabricShareableLinkRequest: MessageFns<GetFabricShareableLinkRequest> = {
  encode(message: GetFabricShareableLinkRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetFabricShareableLinkRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetFabricShareableLinkRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetFabricShareableLinkRequest {
    return { fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "" };
  },

  toJSON(message: GetFabricShareableLinkRequest): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetFabricShareableLinkRequest>, I>>(base?: I): GetFabricShareableLinkRequest {
    return GetFabricShareableLinkRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetFabricShareableLinkRequest>, I>>(
    object: I,
  ): GetFabricShareableLinkRequest {
    const message = createBaseGetFabricShareableLinkRequest();
    message.fabricId = object.fabricId ?? "";
    return message;
  },
};

function createBaseGetFabricShareableLinkResponse(): GetFabricShareableLinkResponse {
  return { fabricId: "", fabricName: "", link: "" };
}

export const GetFabricShareableLinkResponse: MessageFns<GetFabricShareableLinkResponse> = {
  encode(message: GetFabricShareableLinkResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fabricId !== "") {
      writer.uint32(10).string(message.fabricId);
    }
    if (message.fabricName !== "") {
      writer.uint32(18).string(message.fabricName);
    }
    if (message.link !== "") {
      writer.uint32(26).string(message.link);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetFabricShareableLinkResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetFabricShareableLinkResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.fabricName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.link = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetFabricShareableLinkResponse {
    return {
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      fabricName: isSet(object.fabricName) ? globalThis.String(object.fabricName) : "",
      link: isSet(object.link) ? globalThis.String(object.link) : "",
    };
  },

  toJSON(message: GetFabricShareableLinkResponse): unknown {
    const obj: any = {};
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.fabricName !== "") {
      obj.fabricName = message.fabricName;
    }
    if (message.link !== "") {
      obj.link = message.link;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetFabricShareableLinkResponse>, I>>(base?: I): GetFabricShareableLinkResponse {
    return GetFabricShareableLinkResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetFabricShareableLinkResponse>, I>>(
    object: I,
  ): GetFabricShareableLinkResponse {
    const message = createBaseGetFabricShareableLinkResponse();
    message.fabricId = object.fabricId ?? "";
    message.fabricName = object.fabricName ?? "";
    message.link = object.link ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function toTimestamp(date: Date): Timestamp {
  const seconds = Math.trunc(date.getTime() / 1_000).toString();
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (globalThis.Number(t.seconds) || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
